/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ValueobjectTaxMethod {
  TaxMethodExcluded = 1,
  TaxMethodIncluded = 2,
}

export enum ValueobjectTaxInputFormat {
  TaxInputFormatExternal = 1,
  TaxInputFormatInternal = 2,
}

export enum ValueobjectTaxDeclarationMode {
  TaxDeclarationIncreaseAll = 1,
  TaxDeclarationIncreaseFiscalYear = 2,
}

export enum ValueobjectTaxDeclarationIncreaseCause {
  TaxDeclarationIncreaseCauseNew = 1,
  TaxDeclarationIncreaseCauseOld = 2,
  TaxDeclarationIncreaseCauseMove = 3,
  TaxDeclarationIncreaseCauseOthers = 4,
}

export enum ValueobjectTaxDeclarationDecreaseType {
  TaxDeclarationDecreaseTypeAll = 1,
  TaxDeclarationDecreaseTypePartial = 3,
}

export enum ValueobjectTaxDeclarationDecreaseCause {
  TaxDeclarationDecreaseCauseSale = 1,
  TaxDeclarationDecreaseCauseRetire = 2,
  TaxDeclarationDecreaseCauseMove = 3,
  TaxDeclarationDecreaseCauseOthers = 4,
}

export enum ValueobjectSlipDateType {
  SlipDateTypeFixedAssetLedger = 1,
  SlipDateTypeEndOfClosingMonth = 2,
}

export enum ValueobjectRetirementDepreciationEndedMethod {
  RdemEndOfCurrentMonth = 1,
  RdemEndOfLastMonth = 2,
  RdemEndOfLastHalfTerm = 3,
  RdemEndOfLastQuarterTerm = 4,
  RdemEndOfLastTerm = 5,
  RdemEndOfDepreciation = 6,
  RdemSelectOnRetirement = 9,
}

export enum ValueobjectRecalculateStatus {
  RecalculateInProgress = 0,
  RecalculateDone = 1,
  RecalculateFailed = 2,
}

export enum ValueobjectOperationType {
  Registration = 1,
  Update = 2,
  Delete = 3,
  Correct = 4,
  Remove = 5,
  Divide = 6,
  FACorrect = 7,
  AIAgentSettingToggle = 8,
}

export enum ValueobjectOperationTarget {
  FixedAsset = 1,
  EventOfFixedAsset = 2,
  AcceleratedDepreciation = 3,
  AIAgentSetting = 4,
}

export enum ValueobjectOperationCombined {
  OperationCombinedNoPermission = 0,
  OperationCombinedReadOnly = 1,
  OperationCombinedCRU = 7,
  OperationCombinedCRUD = 15,
  OperationCombinedExecute = 16,
}

export enum ValueobjectMovementDepreciationAmountMethod {
  MdamRecordedAtDestination = 1,
  MdamRecordedAtSource = 2,
  MdamSelectOnMovement = 9,
}

export enum ValueobjectMonthlyResidualMethod {
  MrmYearEnd = 1,
  MrmHalfYearEnd = 2,
  MrmQuarterYearEnd = 3,
  MrmMonthly = 4,
}

export enum ValueobjectMonthlyClosingCycle {
  MonthlyClosingCycleMonth = 1,
  MonthlyClosingCycleQuarter = 2,
}

export enum ValueobjectMonthlyClosingAction {
  MonthlyClosingActionOpen = 1,
  MonthlyClosingActionClose = 2,
  MonthlyClosingActionReopen = 3,
}

export enum ValueobjectMaximumDepreciationReachedYearCalculationMethod {
  MdrycmRecordedDirectly = 1,
  MdrycmEqualizeAllMonths = 2,
}

export enum ValueobjectLumpSumDepreciableAssetRoundingOn {
  LsdaroRecordedTo4ThYear = 1,
  LsdaroRecordedToLastMonthOf3RdYear = 2,
}

export enum ValueobjectLinkedStatus {
  LinkedStatusUnexported = 0,
  LinkedStatusLinked = 1,
  LinkedStatusNeedToLinkAgain = 2,
}

export enum ValueobjectLedgerPurpose {
  LpAccountingStandards = 1,
  LpTaxStandards = 2,
  LpIFRSStandards = 3,
  LpTaxAccoutingStandards = 4,
  LpOtherStandards = 9,
}

export enum ValueobjectLackOfMonthSetting {
  LackOfMonthSettingInLastQuarter = 0,
  LackOfMonthSettingInFirstQuarter = 1,
}

export enum ValueobjectJournalLinkageStatus {
  JournalLinkageDraft = 1,
  JournalLinkageApproved = 2,
}

export enum ValueobjectJournalEventType {
  JournalEventAcquisition = 1,
  JournalEventRetirement = 2,
  JournalEventSold = 3,
  JournalEventDepreciation = 4,
  JournalEventImpairment = 5,
}

export enum ValueobjectJournalBranchSide {
  JournalBranchSideDebit = 1,
  JournalBranchSideCredit = 2,
}

export enum ValueobjectJournalAllocationType {
  JournalAllocationTypeAsset = 1,
  JournalAllocationTypeExpense = 2,
  JournalAllocationTypeNonTarget = 3,
}

export enum ValueobjectJobType {
  CorporateTaxJobType = "corporate_tax_job_type",
  TaxDeclarationReportJobType = "tax_declaration_report_job_type",
  BulkChangeJobType = "bulk_change_job_type",
  NetsuiteJournalSendingJobType = "netsuite_journal_sending_job_type",
}

export enum ValueobjectInternalRole {
  InternalRoleSuperAdmin = 1,
  InternalRoleOperator = 2,
  InternalRoleNormal = 3,
  InternalSupportTeam = 4,
}

export enum ValueobjectInputTaxWhenRegisterFixedAsset {
  InputTaxWhenRegisterFixedAssetDont = 1,
  InputTaxWhenRegisterFixedAssetDo = 2,
}

export enum ValueobjectImpairmentLossApplyMethod {
  ILAMEndOfCurrentMonth = 1,
  ILAMEndOfLastMonth = 2,
  ILAMSelectOnImpairment = 9,
}

export enum ValueobjectImpairmentJournalType {
  ImpairmentJournalTypeNormal = 1,
  ImpairmentJournalTypeClosing = 2,
}

export enum ValueobjectImpairmentJournalMethod {
  ImpairmentJournalMethodIndirect = 1,
  ImpairmentJournalMethodDirect = 2,
}

export enum ValueobjectImpairmentJournalCycleType {
  ImpairmentJournalCycleTypeMonthly = 1,
  ImpairmentJournalCycleTypeQuarterly = 2,
}

export enum ValueobjectFiveYearsEqualInstallmentRoundingMethod {
  FyeirmRecordedOn6ThYear = 1,
  FyeirmRecordedOnLastMonthOf5ThYear = 2,
}

export enum ValueobjectFID {
  FIDFixedAsset = 1,
  FIDFixedAssetExport = 2,
  FIDStartUsage = 3,
  FIDMove = 4,
  FIDSwitchCategory = 5,
  FIDRetire = 6,
  FIDSale = 7,
  FIDComment = 36,
  FIDImpair = 41,
  FIDAcquisitionTransferList = 8,
  FIDDepreciationResultReport = 11,
  FIDIncDecReport = 12,
  FIDJournalList = 13,
  FIDMonthlyClosingReview = 14,
  FIDExportJournalList = 15,
  FIDJournalLinkage = 40,
  FIDClosingCurrentMonth = 16,
  FIDReopenPreviousMonth = 39,
  FIDDepreciableAssetsTax = 38,
  FIDAccountItem = 17,
  FIDExcise = 18,
  FIDDepartment = 19,
  FIDAssetCategory = 20,
  FIDArea = 21,
  FIDSubmitDest = 22,
  FIDUnit = 23,
  FIDCause = 24,
  FIDTag = 25,
  FIDOffice = 26,
  FIDUser = 27,
  FIDRole = 28,
  FIDAccountingPeriod = 29,
  FIDAutoJournal = 30,
  FIDAutoGenSerialNumber = 31,
  FIDLedgerSetting = 32,
  FIDExciseSetting = 33,
  FIDOnboarding = 34,
  FIDResetAllData = 37,
  FIDModifyAssetType = 42,
  FIDAuditLog = 35,
  FIDUnderOverdepreciation = 43,
  FIDRecalculatingDepreciation = 44,
  FIDDivide = 45,
  FIDCorporateIncomeTax = 46,
  FIDAcceleratedDepreciation = 48,
  FIDServiceLinkage = 49,
  FIDAIAgent = 50,
  FIDPayasyougo = 51,
  FIDSuspenseAccountLedger = 52,
  FIDJournalProcessing = 53,
  FIDAccountItemForJournalProcessing = 54,
}

export enum ValueobjectExportedStatus {
  ExportedStatusUnexported = 0,
  ExportedStatusExported = 1,
  ExportedStatusNeedToExportAgain = 2,
}

export enum ValueobjectExportOutputUnit {
  ExportOutputAssetCategory = 1,
  ExportOutputFixedAsset = 2,
}

export enum ValueobjectExportOutputCurrencyUnit {
  ExportOutputCurrencyYenUnit = 1,
  ExportOutputCurrencySenUnit = 1000,
}

export enum ValueobjectEventTypeCode {
  FixedAssetLedgerETC = 10,
  UsageETC = 20,
  MovementETC = 30,
  RetirementETC = 40,
  SellETC = 50,
  ImpairmentETC = 60,
  AssetTypeETC = 70,
}

export enum ValueobjectEditTax {
  EditTaxCant = 1,
  EditTaxCan = 2,
}

export enum ValueobjectDepreciationMethod {
  DepreciationMethodOldStraigthLine = 10,
  DepreciationMethodNewStraigthLine = 11,
  DepreciationMethodOldDecliningBalance = 20,
  DepreciationMethodNewDecliningBalance250 = 21,
  DepreciationMethodNewDecliningBalance200 = 22,
  DepreciationMethodBulkEqualInstallment = 30,
  DepreciationMethodDefferedEqualInstallment = 40,
  DepreciationMethodAverageUsagePeriod = 50,
  DepreciationMethodLeasePeriodStraightLine = 60,
  DepreciationMethodAfterImpairmentStraightLine = 70,
  DepreciationMethodAfterImpairmentDecliningBalance = 71,
  DepreciationMethodPettySumDepreciableAsset = 80,
  DepreciationMethodNonDepreciable = 90,
  DepreciationMethodNonDepreciation = 99,
}

export enum ValueobjectDepreciationJournalType {
  DepreciationJournalTypeNormal = 1,
  DepreciationJournalTypeClosing = 2,
}

export enum ValueobjectDepreciationJournalMethod {
  DepreciationJournalMethodIndirect = 1,
  DepreciationJournalMethodDirect = 2,
}

export enum ValueobjectDepreciationJournalCycleType {
  DepreciationJournalCycleTypeMonthly = 1,
  DepreciationJournalCycleTypeQuarterly = 2,
}

export enum ValueobjectDepreciationFixedAssetTaxFiscalYear {
  Reiwa042022 = 2022,
  Reiwa052022 = 2023,
}

export enum ValueobjectDefaultTermMonthDateEnum {
  DefaultTermMonthDateStartDate = 1,
  DefaultTermMonthDateEndDate = 2,
}

export enum ValueobjectCreateJournalMethod {
  CreateJournalMethodOnlyAssetCategory = 1,
  CreateJournalMethodBothAssetCategoryAndFixedAsset = 2,
  CreateJournalMethodOnlyFixedAsset = 3,
}

export enum ValueobjectCorpTaxReportType {
  ReportTypeAssetType = 1,
  ReportTypeAssetCategory = 2,
}

export enum ValueobjectCorpTaxReportTemplateID {
  ReportTemplate1 = 1,
  ReportTemplate2 = 2,
  ReportTemplate4 = 4,
  ReportTemplate6 = 6,
  ReportTemplate7 = 7,
  ReportTemplate8 = 8,
}

export enum ValueobjectChangeSituation {
  AcquisitionCSC = 10,
  AcceptanceOfTransitionCSC = 11,
  UsageStartedCSC = 20,
  RetirementCSC = 30,
  SellCSC = 40,
  MovementCSC = 50,
  DivisionCSC = 53,
  ImpairmentCSC = 60,
  PartialImpairmentCSC = 61,
  CateSwitchedCSC = 90,
  OtherChangeCSC = 99,
}

export enum ValueobjectCauseType {
  AcquisitionCauseType = 1,
  UsageStartedCauseType = 2,
  RetirementCauseType = 10,
  SellCauseType = 20,
  MovementCauseType = 30,
  DivideCauseType = 31,
  ImpairmentCauseType = 40,
  SwitchCategoryCauseType = 70,
  OtherChangeCauseType = 90,
  CorrectionCancelledCauseType = 99,
}

export enum ValueobjectBulkEqualInstallmentFirstYearMethod {
  BifyInterimSettlementAllAmount = 1,
  BifyEqualizeOneYear = 2,
}

export enum ValueobjectBulkEqualInstallmentDepreciationMethod {
  BulkEqualDepreciationContinue = 1,
  BulkEqualDepreciationStop = 2,
}

export enum ValueobjectAutomaticJournalEntryAccquisitionType {
  AutomaticJournalEntryAccquisitionTypeDont = 1,
  AutomaticJournalEntryAccquisitionTypeDo = 2,
}

export enum ValueobjectAutoSaveType {
  AutoSaveTypeCreateFixedAsset = "create-fixed-asset",
  AutoSaveTypeEditFixedAsset = "edit-fixed-asset",
  AutoSaveTypeCopyFixedAsset = "copy-fixed-asset",
}

export enum ValueobjectAssetTypeForDepreciablePropertyTaxCode {
  AssetTypeForDepreciablePropertyTaxCodeConstruction = 1,
  AssetTypeForDepreciablePropertyTaxCodeMachineryAndAppliance = 2,
  AssetTypeForDepreciablePropertyTaxCodeShip = 3,
  AssetTypeForDepreciablePropertyTaxCodeAirCraft = 4,
  AssetTypeForDepreciablePropertyTaxCodeVehiclesAndTransporatationEquipments = 5,
  AssetTypeForDepreciablePropertyTaxCodeToolsAndUtensilAndFurniture = 6,
  AssetTypeForDepreciablePropertyTaxCodeOutOfTarget = 99,
}

export enum ValueobjectAssetTypeForCorporateTaxCode {
  AssetTypeForCorporateTaxCodeBuilding = 10,
  AssetTypeForCorporateTaxCodeBuildingEquipment = 11,
  AssetTypeForCorporateTaxCodeConstruction = 12,
  AssetTypeForCorporateTaxCodeShip = 13,
  AssetTypeForCorporateTaxCodeAirCraft = 14,
  AssetTypeForCorporateTaxCodeVehiclesAndTransportationEquipment = 15,
  AssetTypeForCorporateTaxCodeTool = 16,
  AssetTypeForCorporateTaxCodeInstrumentsAndFurniture = 17,
  AssetTypeForCorporateTaxCodeMachineryAndAppliance = 20,
  AssetTypeForCorporateTaxCodeIntangibleAssets = 30,
  AssetTypeForCorporateTaxCodeCreature = 40,
  AssetTypeForCorporateTaxCodePollutionPreventionAssets = 50,
  AssetTypeForCorporateTaxCodeDevelopmentResearchAssets = 60,
  AssetTypeForCorporateTaxCodeOutOfTarget = 99,
  AssetTypeForCorporateTaxCodeUnknown = 999,
}

export enum ValueobjectAssetType {
  AssetTypeTangible = 1,
  AssetTypeIntangible = 2,
}

export enum ValueobjectAssetStatus {
  ToBeAcquiredAS = 1,
  AcquiredBeforeUseAS = 10,
  InServiceDepreciating = 20,
  InServiceDepreciated = 29,
  RetiredOrSoldAS = 30,
  ImpairedAS = 40,
}

export enum ValueobjectAggregateDepreciationMode {
  AggModeNormal = 0,
  AggModeForJournal = 1,
}

export enum ValueobjectAGSNSScope {
  AGSNSScopeForEachPattern = 1,
  AGSNSScopeWholeOffice = 2,
}

export enum ValueobjectAGSNSMethod {
  AGSNSMethodAutoNumbering = 1,
  AGSNSMethodAutoOnlyBranch = 2,
  AGSNSMethodNoAuto = 3,
}

export enum ValueobjectAGSNSLength {
  AGSNSLength5Chars = 1,
  AGSNSLength3Chars = 2,
}

export enum ValueobjectAGSNSField {
  AGSNSFieldAssetCategory = 1,
  AGSNSFieldAcquisitionDate = 2,
  AGSNSFieldSymbol = 3,
  AGSNSFieldFixedValue = 4,
  AGSNSFieldSerialNumber = 5,
}

export enum NumRoundingMethod {
  RoundUp = 1,
  RoundDown = 2,
  RoundOff = 3,
}

export interface DtoImportFixedAssetEvent {
  area_code?: string;
  asset_code?: string;
  asset_name?: string;
  asset_type_corporate_tax_code?: string;
  asset_type_corporate_tax_name?: string;
  /** Update Asset Type Event */
  asset_type_depreciable_property_tax_code?: string;
  asset_type_depreciable_property_tax_name?: string;
  asset_type_detail_corporate_tax?: string;
  asset_type_structure_corporate_tax?: string;
  biid?: string;
  branch_code?: string;
  cause_code?: string;
  cause_id?: number;
  cause_name?: string;
  department_code?: string;
  /** Sale and Retirement */
  depreciation_ended_method?: number;
  disposal_cost?: number;
  disposal_destination?: string;
  disposal_excise?: EntityExcise;
  disposal_excise_master_id?: number;
  disposal_excise_short_name?: string;
  disposal_excise_type?: string;
  disposal_tax_amount?: number;
  id?: number;
  impair_dem?: number;
  /** Impair Event */
  impaired_at?: string;
  lineNo?: number;
  manual_sold_excise_value?: number;
  /** movement event */
  moved_at?: string;
  reference_link?: string;
  /** Retirement Event */
  retired_at?: string;
  sold_amount?: number;
  /** sale event */
  sold_at?: string;
  sold_destination?: string;
  sold_excise?: EntityExcise;
  sold_excise_master_id?: number;
  /** excise */
  sold_excise_short_name?: string;
  /** Start Usage Event */
  start_usage_at?: string;
}

export interface DtoJournalLinkageStatusResponse {
  journal_linkage_status?: number;
  last_submit_in_current_month?: string;
  permission_status?: string[];
}

export interface EntityExcise {
  code?: string;
  dispOrder?: number;
  exciseLabel?: EntityExciseLabel;
  exciseLabelID?: number;
  exciseMasterID?: number;
  exciseRate?: EntityExciseRate;
  exciseRateID?: number;
  externalCode?: string;
  id?: number;
  isActive?: boolean;
  longName?: string;
  officeID?: number;
  searchKey?: string;
  shortName?: string;
  simpleExcise?: EntitySimpleExcise;
  simpleExciseID?: number;
  tmpVisibleFlg?: boolean;
}

export interface EntityExciseLabel {
  abbreviation?: string;
  id?: number;
  isCalcByIndividual?: boolean;
  name?: string;
  side?: number;
  targetType?: string;
}

export interface EntityExciseRate {
  endDate?: string;
  id?: number;
  rate?: number;
  reducedFlg?: boolean;
  startDate?: string;
  totalPercentage?: number;
}

export interface EntitySimpleExcise {
  id?: number;
  name?: string;
  rate?: number;
}

export interface ErrorsResponseErrSource {
  parameter?: string;
  pointer?: string;
}

export interface ErrorsResponseError {
  attributes?: Record<string, any>;
  biids?: string[];
  code?: string;
  detail?: string;
  errline?: number;
  source?: ErrorsResponseErrSource;
  status?: string;
}

export interface HandlerFrontendBaseURLResponse {
  frontend_base_url?: string;
}

export interface PresenterAAOffice {
  id?: number;
  identification_code?: string;
  name?: string;
}

export interface PresenterAAUser {
  email?: string;
  id?: number;
  identification_code?: string;
}

export interface PresenterAIAgentSettingResponse {
  consented_at?: string;
  enabled?: boolean;
  has_consented?: boolean;
}

export interface PresenterAWebAgentLoginAuthRequest {
  client_id: string;
  code_challenge: string;
  code_challenge_method: string;
  nonce: string;
  office_id: number;
  reason: string;
  redirect_url: string;
  response_type?: string;
}

export interface PresenterAWebAgentLoginCodeResponse {
  auth_code?: string;
  redirect_url?: string;
}

export interface PresenterAWebNotification {
  display_order?: number;
  id?: number;
  is_displayed?: boolean;
  is_highlighted?: boolean;
  released_at?: string;
  title?: string;
  url?: string;
}

export interface PresenterAWebNotificationListResponse {
  data?: PresenterAWebNotification[];
  displayed_total?: number;
}

export interface PresenterAcceleratedDepreciationRequest {
  depr_months?: PresenterMonthlyDepreciationValues[];
  ledger_setting_id?: number;
  selected_date?: string;
}

export interface PresenterAccountItem {
  account_sub_items?: PresenterAccountSubItem[];
  /** @maxLength 10 */
  code: string;
  deleted?: boolean;
  /** @min 1 */
  excise_id: number;
  /** @min 1 */
  id?: number;
  index?: number;
  /** @maxLength 30 */
  name: string;
  /** @maxLength 20 */
  search_key?: string;
}

export interface PresenterAccountJournalAccountItemResponse {
  code?: string;
  id?: number;
  is_active?: boolean;
  name?: string;
  search_key?: string;
}

export interface PresenterAccountJournalAccountSubItemResponse {
  account_item_id?: number;
  code?: string;
  id?: number;
  is_active?: boolean;
  name?: string;
  search_key?: string;
}

export interface PresenterAccountSubItem {
  /** @maxLength 10 */
  code: string;
  deleted?: boolean;
  /** @min 1 */
  excise_id: number;
  /** @min 1 */
  id?: number;
  index?: number;
  /** @maxLength 30 */
  name: string;
  /** @maxLength 20 */
  search_key?: string;
}

export interface PresenterAgentLoginSessionRequest {
  code: string;
  code_verifier: string;
  nonce: string;
}

export interface PresenterAggregateDepreciationResultResponse {
  items?: PresenterTypeItemAmount[];
  ledger_setting?: PresenterOneLedgerSettingResponse;
  term_months?: PresenterOneShortTermMonthResponse[];
  year?: number;
}

export interface PresenterAllocateBatchRequest {
  /** @minItems 1 */
  items: PresenterAllocateItemRequest[];
}

export interface PresenterAllocateItemRequest {
  allocation_type: ValueobjectJournalAllocationType;
  amount: number;
  side_id: number;
}

export interface PresenterAllocateItemResult {
  allocation_id?: number;
  new_allocated?: number;
  new_remaining?: number;
  side_id?: number;
}

export interface PresenterAlternativeMatch {
  asset_category_code?: string;
  asset_category_name?: string;
  confidence?: number;
  logic_path?: string;
  nta_link?: string;
  reasoning?: string;
  service_life?: number;
}

export interface PresenterAmountByMonth {
  amount?: number;
  term_month_id?: number;
}

export interface PresenterAnnualDepreciationAmountResponse {
  acceptance_amt?: number;
  depreciation_amt_accountant_ledger?: number;
  depreciation_limit_amt_tax_ledger?: number;
  loss_allowance_amt?: number;
  over_depreciation_amt?: number;
  over_depreciation_amt_carried_last_period?: number;
  over_depreciation_amt_carried_next_period?: number;
  under_depreciation_amt?: number;
}

export interface PresenterAnnualDepreciationResponse {
  items?: PresenterAnnualDepreciationSummaryResponse[];
  term?: PresenterOneTermResponse[];
}

export interface PresenterAnnualDepreciationSummaryResponse {
  asset_category_amounts?: PresenterAssetCategoryAnnualDepreciationResponse[];
  total_depreciation_amount?: PresenterAnnualDepreciationAmountResponse;
  type?: string;
}

export interface PresenterAreaFilter {
  "filter[biid]"?: string[];
  "filter[code]"?: string;
  "filter[is_show_future]"?: boolean;
  "filter[is_show_past]"?: boolean;
  "filter[name]"?: string;
  "filter[search_key]"?: string;
  "filter[submit_destination_id]"?: number;
  "filter[valid_at]"?: string;
  "page[number]"?: number;
  "page[size]"?: number;
  sort?: string[];
}

export interface PresenterAssetAnnualDepreciationResponse {
  asset_depreciation_amount?: PresenterAnnualDepreciationAmountResponse;
  biid?: string;
  branch_code?: string;
  code?: string;
  is_deleted?: boolean;
  name?: string;
}

export interface PresenterAssetCategoryAnnualDepreciationResponse {
  asset_category_code?: string;
  asset_category_name?: string;
  category_depreciation_amount?: PresenterAnnualDepreciationAmountResponse;
  fixed_asset_amounts?: PresenterAssetAnnualDepreciationResponse[];
}

export interface PresenterAssetCategoryItemAmount {
  amount_months?: PresenterAmountByMonth[];
  asset_category_code?: string;
  asset_category_name?: string;
  items?: PresenterAssetItemAmount[];
  total_amount?: number;
}

export interface PresenterAssetCategoryRequest {
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type: ValueobjectAssetType;
  asset_type_for_corporate_tax?: ValueobjectAssetTypeForCorporateTaxCode;
  asset_type_for_depreciable_property_tax?: ValueobjectAssetTypeForDepreciablePropertyTaxCode;
  /** @maxLength 10 */
  code: string;
  depreciation_method?: ValueobjectDepreciationMethod;
  excise_id?: number;
  /** @maxLength 50 */
  name: string;
  /** @maxLength 20 */
  search_key?: string;
  service_life?: number;
}

export interface PresenterAssetItemAmount {
  amount_months?: PresenterAmountByMonth[];
  biid?: string;
  branch_code?: string;
  code?: string;
  depreciation_method?: PresenterMasterDataValue;
  name?: string;
  service_life?: number;
  total_amount?: number;
  usage_period_months?: number;
  usage_started_at?: string;
}

export interface PresenterAssetType {
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
}

export interface PresenterAssignRolesForUserRequest {
  /** @minItems 1 */
  role_biids: string[];
  user_id: number;
}

export interface PresenterAttachmentInformation {
  filename?: string;
  id: string;
  mime_type?: string;
  url?: string;
}

export interface PresenterAutoGeneratingSerialNumberSettingFilter {
  sort?: string[];
}

export interface PresenterAwebFullOfficeResponse {
  contract?: PresenterContractResponse;
  id?: number;
  identification_code?: string;
  name?: string;
  tenant_type?: string;
  total_assets?: number;
  total_ledgers?: number;
  total_users?: number;
}

export interface PresenterAwebOfficeResponse {
  contract?: PresenterContractResponse;
  id?: number;
  identification_code?: string;
  name?: string;
  tenant_type?: string;
}

export interface PresenterAwebUserResponse {
  created_at?: string;
  email?: string;
  id?: number;
  identification_code?: string;
  offices?: PresenterOneOfficeResponse[];
  updated_at?: string;
}

export interface PresenterBIIDResponse {
  biid?: string;
}

export interface PresenterBulkChangeMovementReq {
  area_biid?: string;
  biids: string[];
  department_biid?: string;
  event_cause_id: number;
  moved_at: string;
}

export interface PresenterBulkDeleteFixedAssetRequest {
  data: PresenterDeleteFixedAssetRequest[];
}

export interface PresenterBulkRetireFixedAssetRequest {
  biids: string[];
  event_cause_id: number;
  retired_at: string;
  retirement_fixed_asset_ledger_requests: PresenterRetirementFixedAssetLedgerRequest[];
}

export interface PresenterBulkUpdateAssetTypeRequest {
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  biids: string[];
}

export interface PresenterBulkUsageFixedAssetRequest {
  biids: string[];
  event_cause_id?: number;
  usage_started_at?: string;
}

export interface PresenterCalculateExciseValueRequest {
  /** @example "2021-03-03" */
  at: string;
  excise_id: number;
  input_value: number;
}

export interface PresenterCalculatedExciseValueResponse {
  excise_value?: number;
  excluded_excise_value?: number;
  included_excise_value?: number;
}

export interface PresenterCancelAcceleratedDepreciationRequest {
  ledger_setting_id?: number;
}

export interface PresenterChangeTagPositionRequest {
  id_after?: string;
  id_before?: string;
  target_id?: string;
}

export interface PresenterChangeUnitPositionRequest {
  id_after?: number;
  id_before?: number;
  target_id?: number;
}

export interface PresenterChoices {
  is_cru_permission?: boolean;
  is_crud_permission?: boolean;
  is_execute_permission?: boolean;
  is_no_permission?: boolean;
  is_read_permission?: boolean;
}

export interface PresenterCityCode {
  code?: string;
  name?: string;
}

export interface PresenterConfirmDraftItem {
  draft_id?: number;
  fixed_asset_biid?: string;
  status?: number;
}

export interface PresenterConfirmDraftResponse {
  items?: PresenterConfirmDraftItem[];
}

export interface PresenterContractResponse {
  created_at?: string;
  end_date?: string;
  id?: number;
  office_id?: number;
  reason?: string;
  start_date?: string;
  type?: number;
  updated_at?: string;
}

export interface PresenterCorporateTaxDataResponse {
  data?: string[][];
  era_years?: string[][];
  /** relation data */
  office_name?: string;
}

export interface PresenterCorporateTaxExportHistoryResponse {
  created_at?: string;
  created_by_name?: string;
  file_name?: string;
  id?: number;
  office_id?: number;
  report_template_id?: ValueobjectCorpTaxReportTemplateID;
  report_type?: ValueobjectCorpTaxReportType;
  term_id?: number;
  url?: string;
}

export interface PresenterCorporateTaxHistoryCountResponse {
  count?: number;
  report_template_id?: ValueobjectCorpTaxReportTemplateID;
}

export interface PresenterCorporateTaxOptionResponse {
  last_export?: PresenterCorporateTaxExportHistoryResponse;
  terms?: PresenterOneShortTermResponse[];
}

export interface PresenterCorrectFixedAssetRequest {
  /** master data */
  acquire_category_code: number;
  acquire_destination_name?: string;
  acquired_at: string;
  acquisition_cost: number;
  acquisition_cost_excluded_excise?: number;
  area_biid: string;
  asset_category_id: number;
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  attachments?: PresenterAttachmentInformation[];
  /** @maxLength 3 */
  branch_code?: string;
  calculated_excise_value?: number;
  /**
   * The max rule should be sync with entity.maximumLedgersOfFixedAssetCode const
   * @maxLength 20
   */
  code?: string;
  comment?: string;
  department_biid?: string;
  dry_run?: boolean;
  excise_id?: number;
  /** @min 1 */
  exemption_denominator?: number;
  /** @min 1 */
  exemption_numerator?: number;
  fixed_asset_ledgers: PresenterCreateFixedAssetLedgerRequest[];
  generating_method?: ValueobjectAGSNSMethod;
  index?: number;
  is_excluded?: boolean;
  manual_excise_value?: number;
  memo?: string;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 100 */
  name_kana?: string;
  photos?: PresenterPhotoInformation[];
  /** @maxLength 50 */
  pre_submit_number?: string;
  quantity?: number;
  reduction_amount?: number;
  subsidy_amount?: number;
  /** @maxLength 100 */
  summary_for_asset_depreciation_tax?: string;
  tags?: PresenterOneTagResponse[];
  transition_at?: string;
  unit_id?: number;
  urls?: string[];
  usage_started_at?: string;
}

export interface PresenterCountFixedAssetCommentRequrest {
  fixed_asset_biids: string[];
}

export interface PresenterCreateAWebNotificationRequest {
  /** @min 1 */
  display_order: number;
  is_displayed?: boolean;
  is_highlighted?: boolean;
  released_at: string;
  /** @maxLength 255 */
  title: string;
  /** @maxLength 400 */
  url: string;
}

export interface PresenterCreateAreaRequest {
  attachments?: PresenterAttachmentInformation[];
  code?: string;
  name?: string;
  photos?: PresenterPhotoInformation[];
  search_key?: string;
  submit_destination_id?: number;
  urls?: string[];
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterCreateCauseRequest {
  code?: string;
  content?: string;
  search_key?: string;
  type: ValueobjectCauseType;
}

export interface PresenterCreateDepartmentRequest {
  code?: string;
  name?: string;
  prepress_category_code?: number;
  ref_id?: number;
  search_key?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterCreateFixedAssetCommentRequest {
  content: string;
}

export interface PresenterCreateFixedAssetLedgerRequest {
  accounting_beginning_book_initial_value?: number;
  accumulated_impaired_amount?: number;
  accumulated_over_depreciation_amt?: number;
  acquisition_cost_for_straight_line?: number;
  book_value_after_impairment?: number;
  /**
   * @min 1
   * @max 999
   */
  depreciated_months?: number;
  depreciation_method_code: ValueobjectDepreciationMethod;
  impaired_at?: string;
  ledger_setting_id: number;
  memorandum_value?: number;
  remaining_service_life_after_impairment?: number;
  remaining_usage_period_after_impairment?: number;
  residual_amount?: number;
  residual_value_after_impairment?: number;
  revised_acquisition_amount?: number;
  /**
   * @min 0
   * @max 100
   */
  service_life?: number;
  /**
   * @min 2
   * @max 150
   */
  service_life_for_depreciation_calc?: number;
  theoretical_beginning_book_value?: number;
  transition_beginning_book_value?: number;
  transition_book_value?: number;
  usage_period_months?: number;
}

export interface PresenterCreateFixedAssetRequest {
  /** master data */
  acquire_category_code: number;
  acquire_destination_name?: string;
  acquired_at: string;
  acquisition_cost: number;
  acquisition_cost_excluded_excise?: number;
  area_biid: string;
  asset_category_id: number;
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  attachments?: PresenterAttachmentInformation[];
  /** @maxLength 3 */
  branch_code?: string;
  calculated_excise_value?: number;
  /**
   * The max rule should be sync with entity.maximumLedgersOfFixedAssetCode const
   * @maxLength 20
   */
  code?: string;
  comment?: string;
  department_biid?: string;
  dry_run?: boolean;
  excise_id?: number;
  /** @min 1 */
  exemption_denominator?: number;
  /** @min 1 */
  exemption_numerator?: number;
  fixed_asset_ledgers: PresenterCreateFixedAssetLedgerRequest[];
  generating_method?: ValueobjectAGSNSMethod;
  index?: number;
  is_excluded?: boolean;
  manual_excise_value?: number;
  memo?: string;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 100 */
  name_kana?: string;
  photos?: PresenterPhotoInformation[];
  /** @maxLength 50 */
  pre_submit_number?: string;
  quantity?: number;
  reduction_amount?: number;
  subsidy_amount?: number;
  /** @maxLength 100 */
  summary_for_asset_depreciation_tax?: string;
  tags?: PresenterOneTagResponse[];
  transition_at?: string;
  unit_id?: number;
  urls?: string[];
  usage_started_at?: string;
}

export interface PresenterCreateInternalUserRequest {
  email: string;
  role: ValueobjectInternalRole;
}

export interface PresenterCreateJournalItemSettingRequest {
  acquisition_credit_payment_category_account_item_id?: number;
  acquisition_credit_payment_category_account_sub_item_id?: number;
  /** Acquisition - 取得 */
  acquisition_debit_asset_category_account_item_id?: number;
  acquisition_debit_asset_category_account_sub_item_id?: number;
  /** @maxLength 1000 */
  acquisition_remark?: string;
  asset_category_id: number;
  depreciation_credit_accumulated_account_item_id?: number;
  depreciation_credit_accumulated_account_sub_item_id?: number;
  depreciation_credit_asset_category_account_item_id?: number;
  depreciation_credit_asset_category_account_sub_item_id?: number;
  /** Depreciation - 減価償却 */
  depreciation_debit_account_item_id?: number;
  depreciation_debit_account_sub_item_id?: number;
  /** @maxLength 1000 */
  depreciation_remark?: string;
  from_term_month_id: number;
  impairment_credit_accumulated_impairment_account_item_id?: number;
  impairment_credit_accumulated_impairment_account_sub_item_id?: number;
  impairment_credit_asset_category_account_item_id?: number;
  impairment_credit_asset_category_account_sub_item_id?: number;
  /** Impairment */
  impairment_debit_loss_account_item_id?: number;
  impairment_debit_loss_account_sub_item_id?: number;
  /** @maxLength 1000 */
  impairment_remark?: string;
  retirement_credit_asset_category_account_item_id?: number;
  retirement_credit_asset_category_account_sub_item_id?: number;
  retirement_credit_payment_category_account_item_id?: number;
  retirement_credit_payment_category_account_sub_item_id?: number;
  /** Retirement - 除却 */
  retirement_debit_accumulated_depreciation_account_item_id?: number;
  retirement_debit_accumulated_depreciation_account_sub_item_id?: number;
  retirement_debit_accumulated_impairment_account_item_id?: number;
  retirement_debit_accumulated_impairment_account_sub_item_id?: number;
  retirement_debit_loss_account_item_id?: number;
  retirement_debit_loss_account_sub_item_id?: number;
  /** @maxLength 1000 */
  retirement_remark?: string;
  sale_credit_asset_category_account_item_id?: number;
  sale_credit_asset_category_account_sub_item_id?: number;
  sale_credit_gain_account_item_id?: number;
  sale_credit_gain_account_sub_item_id?: number;
  sale_credit_payment_category_account_item_id?: number;
  sale_credit_payment_category_account_sub_item_id?: number;
  /** Sale - 売却 */
  sale_debit_accumulated_depreciation_account_item_id?: number;
  sale_debit_accumulated_depreciation_account_sub_item_id?: number;
  sale_debit_accumulated_impairment_account_item_id?: number;
  sale_debit_accumulated_impairment_account_sub_item_id?: number;
  sale_debit_loss_account_item_id?: number;
  sale_debit_loss_account_sub_item_id?: number;
  sale_debit_revenue_account_item_id?: number;
  sale_debit_revenue_account_sub_item_id?: number;
  /** @maxLength 1000 */
  sale_remark?: string;
}

export interface PresenterCreateJournalSettingRequest {
  create_journal_method: ValueobjectCreateJournalMethod;
  depreciation_journal_cycle_type: ValueobjectDepreciationJournalCycleType;
  depreciation_journal_method: ValueobjectDepreciationJournalMethod;
  depreciation_journal_type: ValueobjectDepreciationJournalType;
  from_term_month_id: number;
  impairmentJournalCycleType?: ValueobjectImpairmentJournalCycleType;
  impairmentJournalMethod?: ValueobjectImpairmentJournalMethod;
  impairmentJournalType?: ValueobjectImpairmentJournalType;
  journal_linkage_status: ValueobjectJournalLinkageStatus;
  paid_excise_debit_account_item_id: number;
  received_excise_debit_account_item_id: number;
  slip_date_type: ValueobjectSlipDateType;
}

export interface PresenterCreateOfficeRequest {
  id?: number;
}

export interface PresenterCreateOfficeUserRequest {
  tenant_user_uid?: number;
}

export interface PresenterCreateSubmitDestinationRequest {
  apply_destination?: string;
  asset_location_1?: string;
  asset_location_2?: string;
  asset_location_3?: string;
  capital_amount?: number;
  city_code?: string;
  code?: string;
  commercial_name?: string;
  company_established_at_month?: number;
  company_established_at_year?: number;
  company_name?: string;
  company_name_kana?: string;
  corporate_code?: string;
  details_export_setting?: number;
  district_code?: string;
  has_additional_depreciation_report?: boolean;
  has_approval_of_shortened_service_life?: boolean;
  has_blue_return?: boolean;
  has_borrow_asset?: boolean;
  has_depreciation_method_on_ta_for_dbm?: boolean;
  has_depreciation_method_on_ta_for_slm?: boolean;
  has_non_taxable_asset?: boolean;
  has_special_depreciation_or_compress_entry?: boolean;
  has_taxation_standard_special?: boolean;
  industry_category?: string;
  lender_name?: string;
  name?: string;
  owner_address?: string;
  owner_address_kana?: string;
  owner_category_of_building_of_company_rented_house?: boolean;
  owner_category_of_building_of_company_self_owned?: boolean;
  owner_code?: string;
  /** @example "123-1234-122" */
  owner_telephone?: string;
  /** @example "123-1234" */
  owner_zip_code?: string;
  person_in_charge_department?: string;
  person_in_charge_name?: string;
  /** @example "123-1234-122" */
  person_in_charge_telephone?: string;
  remark?: string;
  representative_name?: string;
  representative_name_kana?: string;
  representative_position?: string;
  search_key?: string;
  tax_accountant_name?: string;
  /** @example "123-1234-122" */
  tax_accountant_telephone?: string;
}

export interface PresenterCreateTagRequest {
  name?: string;
}

export interface PresenterCreateUnitRequest {
  link_memorandum_value_quantity?: boolean;
  name?: string;
}

export interface PresenterCurrentUser {
  email?: string;
  id?: number;
  identification_code?: string;
  is_confirmed?: boolean;
  last_office_id?: number;
}

export interface PresenterDeletableAccountItem {
  deletable?: boolean;
  item_id?: number;
  messages?: string[];
}

export interface PresenterDeletableAccountSubItem {
  deletable?: boolean;
  messages?: string[];
  sub_item_id?: number;
}

export interface PresenterDeletableDept {
  deletable?: boolean;
  dept_id?: number;
  messages?: string[];
}

export interface PresenterDeletableExcise {
  deletable?: boolean;
  excise_id?: number;
  messages?: string[];
}

export interface PresenterDeleteFixedAssetRequest {
  biid?: string;
  id?: number;
}

export interface PresenterDepartmentFilter {
  "filter[biid]"?: string[];
  "filter[code]"?: string;
  "filter[is_show_future]"?: boolean;
  "filter[is_show_past]"?: boolean;
  "filter[name]"?: string;
  "filter[prepress_category_code]"?: number;
  "filter[search_key]"?: string;
  "filter[valid_at]"?: string;
  "page[number]"?: number;
  "page[size]"?: number;
  sort?: string[];
}

export interface PresenterDepartmentItem {
  abolished?: boolean;
  amount_months?: PresenterAmountByMonth[];
  department_code?: string;
  department_name?: string;
  items?: PresenterAssetCategoryItemAmount[];
  total_amount?: number;
}

export interface PresenterDepreciationAdjustHistory {
  adjusted_accumulated_depreciation_amount?: number;
  depreciation_amount?: number;
  original_depreciation_amount?: number;
  term_month?: PresenterOneFullTermMonthResponse;
}

export interface PresenterDepreciationMonthlyResponse {
  accumulated_depreciation_amount?: number;
  accumulated_impaired_amount?: number;
  adjusted_accumulated_depreciation_amount?: number;
  beginning_book_value?: number;
  depreciation_amount?: number;
  end_date?: string;
  end_of_term_book_value?: number;
  fiscal_year?: number;
  impaired_amount?: number;
  is_adjust?: boolean;
  is_adjustable?: boolean;
  is_impaired?: boolean;
  is_retired_or_sold?: boolean;
  month?: number;
  month_serial_number?: number;
  original_depreciation_amount?: number;
  period?: number;
  start_date?: string;
  term_month_id?: number;
  year?: number;
}

export interface PresenterDepreciationOfOneYearResponse {
  accumulated_depreciation_amount?: number;
  /**
   * tax ledger value
   * AccumulatedRecognizedDepreciationAmt in depreciation_close_years table
   */
  accumulated_recognized_depreciation_amt?: number;
  beginning_book_value?: number;
  /** BookValueOfTaxAnnualDepr = acquisition - adjusted_accumulated_depreciation_amount */
  book_value_of_tax_annual_depr?: number;
  depreciation_amount?: number;
  end_of_term_book_value?: number;
  fiscal_year?: number;
  months?: PresenterDepreciationMonthlyResponse[];
  period?: number;
  term_end_date?: string;
  term_id?: number;
  term_start_date?: string;
}

export interface PresenterDepreciationRecalculateHistoryResponse {
  created_at?: string;
  created_by?: number;
  disable_recalculate?: boolean;
  failed_count?: number;
  office_id?: number;
  status?: ValueobjectRecalculateStatus;
  success_count?: number;
  total?: number;
}

export interface PresenterDepreciationResultsAdjustAdjustmentResponse {
  after?: PresenterDepreciationResultsAdjustment;
  before?: PresenterDepreciationResultsAdjustment;
  fixed_asset?: PresenterFixedAssetAdjustmentResponse;
}

export interface PresenterDepreciationResultsAdjustHistoryResponse {
  biid?: string;
  created_by?: number;
  last_fa_event?: PresenterFixedAssetDepreResultAdjustHistoryResponse;
  monthly_closing?: PresenterMonthlyClosingShortResponse;
  office_id?: number;
  selected_date?: string;
}

export interface PresenterDepreciationResultsAdjustment {
  adjustment?: PresenterDepreciationAdjustHistory[];
  selected_date?: string;
}

export interface PresenterDisableableAccountItem {
  disableable?: boolean;
  item_id?: number;
  messages?: string[];
}

export interface PresenterDisableableAccountSubItem {
  disableable?: boolean;
  messages?: string[];
  sub_item_id?: number;
}

export interface PresenterDistrictCode {
  city_code?: string;
  code?: string;
  name?: string;
}

export interface PresenterDivideAssetDataRequest {
  acquisition_cost: number;
  acquisition_cost_tax_included?: number;
  branch_code?: string;
  /** @maxLength 20 */
  code?: string;
  event_attachments?: PresenterAttachmentInformation[];
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  excise_amount?: number;
  ledgers?: PresenterDivideLedgerRequest[];
  memorandum_value?: number;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 100 */
  name_kana?: string;
  quantity?: number;
  residual_amount?: number;
}

export interface PresenterDivideAssetPreviewRequest {
  divided_acquisition_cost?: number;
  divided_excise_amount?: number;
  new_acquisition_cost?: number;
  new_excise_amount?: number;
}

export interface PresenterDivideAssetPreviewResponse {
  divided_acquisition_cost?: number;
  divided_acquisition_cost_tax_included?: number;
  divided_excise_amount?: number;
  divided_quantity?: number;
  new_acquisition_cost?: number;
  new_acquisition_cost_tax_included?: number;
  new_excise_amount?: number;
  new_quantity?: number;
}

export interface PresenterDivideAssetRequest {
  divided_at: string;
  event_cause_id: number;
  new_asset: PresenterDivideAssetDataRequest;
}

export interface PresenterDivideLedgerRequest {
  memorandum_value?: number;
  residual_amount?: number;
}

export interface PresenterDivideStandardDateLedgerResponse {
  ledger_purpose?: number;
  ledger_setting_id?: number;
  standard_date?: string;
}

export interface PresenterDivideStandardDateRequest {
  biid: string;
  divided_at: string;
}

export interface PresenterDivideStandardDateResponse {
  biid?: string;
  divided_at?: string;
  standard_dates?: PresenterDivideStandardDateLedgerResponse[];
}

export interface PresenterDraftAllocationResponse {
  amount?: number;
  id?: number;
  side_id?: number;
}

export interface PresenterDraftAssignmentRequest {
  allocation_id?: number;
  amount: number;
  remove?: boolean;
  side_id: number;
}

export interface PresenterDraftFixedAssetDetailResponse {
  acquire_category_code?: number;
  acquire_destination_name?: string;
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  acquisition_cost_included_excise?: number;
  area_biid?: string;
  area_name?: string;
  asset_category_id?: number;
  asset_category_name?: string;
  asset_code?: string;
  asset_detail_for_corporate_tax?: string;
  asset_status_code?: number;
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  attachments?: string[];
  calculated_excise_value?: number;
  change_situation_code?: number;
  created_at?: string;
  department_biid?: string;
  department_name?: string;
  event_cause_id?: number;
  event_urls?: string;
  excise_id?: number;
  exemption_denominator?: number;
  exemption_numerator?: number;
  id?: number;
  journal_allocations?: PresenterDraftFixedAssetJournalAllocationItem[];
  ledgers?: PresenterDraftFixedAssetLedgerItem[];
  manual_excise_value?: number;
  memo?: string;
  name?: string;
  name_kana?: string;
  photos?: string[];
  pre_submit_number?: string;
  quantity?: number;
  recognized_at?: string;
  reduction_amount?: number;
  status?: number;
  subsidy_amount?: number;
  tags?: string[];
  unit_id?: number;
  updated_at?: string;
  urls?: string;
  usage_started_at?: string;
}

export interface PresenterDraftFixedAssetJournalAllocationItem {
  account_code?: string;
  account_item_id?: number;
  account_name?: string;
  account_sub_item_id?: number;
  allocated_value?: number;
  allocation_type?: number;
  amount?: number;
  business_partner_id?: number;
  confirmed_at?: string;
  created_at?: string;
  dept_code?: string;
  dept_id?: number;
  dept_name?: string;
  excise_id?: number;
  excise_value?: number;
  id?: number;
  invoice_kind?: string;
  journal_number?: number;
  journal_type?: string;
  memo?: string;
  project_biid?: string;
  recognized_at?: string;
  remark?: string;
  side_id?: number;
  side_type?: number;
  sub_account_code?: string;
  sub_account_name?: string;
  unallocated_value?: number;
  value?: number;
}

export interface PresenterDraftFixedAssetLedgerItem {
  accounting_beginning_book_initial_value?: number;
  acquisition_cost_for_straight_line?: number;
  depreciation_method_code: number;
  id?: number;
  ledger_setting_id: number;
  memorandum_value?: number;
  residual_amount?: number;
  service_life?: number;
  service_life_for_depreciation_calc?: number;
  usage_period_months?: number;
}

export interface PresenterDraftFixedAssetLedgerRequest {
  accounting_beginning_book_initial_value?: number;
  acquisition_cost_for_straight_line?: number;
  depreciation_method_code: ValueobjectDepreciationMethod;
  ledger_setting_id: number;
  memorandum_value?: number;
  residual_amount?: number;
  /**
   * @min 0
   * @max 100
   */
  service_life?: number;
  /**
   * @min 2
   * @max 150
   */
  service_life_for_depreciation_calc?: number;
  usage_period_months?: number;
}

export interface PresenterDraftFixedAssetLedgerResponse {
  accounting_beginning_book_initial_value?: number;
  acquisition_cost_for_straight_line?: number;
  depreciation_method_code?: ValueobjectDepreciationMethod;
  id?: number;
  ledger_setting_id?: number;
  memorandum_value?: number;
  residual_amount?: number;
  service_life?: number;
  service_life_for_depreciation_calc?: number;
  usage_period_months?: number;
}

export interface PresenterDraftFixedAssetListItem {
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  acquisition_cost_included_excise?: number;
  area_biid?: string;
  area_name?: string;
  asset_category_id?: number;
  asset_category_name?: string;
  created_at?: string;
  department_biid?: string;
  department_name?: string;
  id?: number;
  linked_journal_count?: number;
  name?: string;
  name_kana?: string;
  updated_at?: string;
  usage_started_at?: string;
}

export interface PresenterDraftFixedAssetListResponse {
  items?: PresenterDraftFixedAssetListItem[];
}

export interface PresenterDraftFixedAssetResponse {
  acquire_category_code?: number;
  acquire_destination_name?: string;
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  acquisition_cost_included_excise?: number;
  allocations?: PresenterDraftAllocationResponse[];
  area_biid?: string;
  asset_category_id?: number;
  asset_detail_for_corporate_tax?: string;
  asset_status_code?: number;
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  calculated_excise_value?: number;
  change_situation_code?: number;
  department_biid?: string;
  event_cause_id?: number;
  event_urls?: string[];
  excise_id?: number;
  exemption_denominator?: number;
  exemption_numerator?: number;
  fixed_asset_biid?: string;
  id?: number;
  ledgers?: PresenterDraftFixedAssetLedgerResponse[];
  manual_excise_value?: number;
  memo?: string;
  name?: string;
  name_kana?: string;
  pre_submit_number?: string;
  quantity?: number;
  recognized_at?: string;
  reduction_amount?: number;
  status?: number;
  subsidy_amount?: number;
  unit_id?: number;
  urls?: string[];
  usage_started_at?: string;
}

export interface PresenterEditFixedAssetRequest {
  acquire_category_code: number;
  acquire_destination_name?: string;
  attachments?: PresenterAttachmentInformation[];
  department_biid?: string;
  edited_at: string;
  exemption_denominator?: number;
  /**
   * AssetTypeForDepreciablePropertyTaxCode *uint64 `json:"asset_type_for_depreciable_property_tax_code"`
   * AssetTypeForCorporateTaxCode           *uint64 `json:"asset_type_for_corporate_tax_code"`
   * AssetStructureForCorporateTax          *string `json:"asset_structure_for_corporate_tax"`
   * AssetDetailForCorporateTax             *string `json:"asset_detail_for_corporate_tax"`
   */
  exemption_numerator?: number;
  fixed_asset_ledgers?: PresenterFixedAssetLedger[];
  memo?: string;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 100 */
  name_kana?: string;
  photos?: PresenterPhotoInformation[];
  /** @maxLength 50 */
  pre_submit_number?: string;
  quantity?: number;
  /** @maxLength 100 */
  summary_for_asset_depreciation_tax?: string;
  tags?: PresenterOneTagResponse[];
  unit_id?: number;
  urls?: string[];
}

export interface PresenterEditJournalSettingRequest {
  create_journal_method: ValueobjectCreateJournalMethod;
  depreciation_journal_cycle_type: ValueobjectDepreciationJournalCycleType;
  depreciation_journal_method: ValueobjectDepreciationJournalMethod;
  depreciation_journal_type: ValueobjectDepreciationJournalType;
  impairmentJournalCycleType?: ValueobjectImpairmentJournalCycleType;
  impairmentJournalMethod?: ValueobjectImpairmentJournalMethod;
  impairmentJournalType?: ValueobjectImpairmentJournalType;
  journal_linkage_status: ValueobjectJournalLinkageStatus;
  paid_excise_debit_account_item_id: number;
  received_excise_debit_account_item_id: number;
  slip_date_type: ValueobjectSlipDateType;
}

export interface PresenterEditTermRequest {
  default_term_month_date?: 0 | 1 | 2;
  dry_run?: boolean;
  end_date: string;
  lack_of_month_setting?: 0 | 1;
  month_serial_number: number;
  term_id: number;
}

export interface PresenterError {
  attributes?: Record<string, any>;
  biids?: string[];
  code?: string;
  detail?: string;
  line?: number;
  source?: PresenterSource;
  status?: string;
}

export interface PresenterEvaluateBatchFeatureFlagRequest {
  bool_flags: PresenterEvaluateBoolRequest[];
}

export interface PresenterEvaluateBatchFeatureFlagResponse {
  bool_flags?: PresenterEvaluateBoolResponse[];
}

export interface PresenterExciseSettingResponse {
  automatic_journal_entry_accquisition_type?: ValueobjectAutomaticJournalEntryAccquisitionType;
  can_edit_tax?: ValueobjectEditTax;
  created_at?: string;
  default_excise_disposal_cost_id?: number;
  default_excise_sell_id?: number;
  from_term?: PresenterOneTermResponse;
  from_term_id?: number;
  id?: number;
  input_tax_when_register_fixed_asset?: ValueobjectInputTaxWhenRegisterFixedAsset;
  office_id?: number;
  rounding_method?: NumRoundingMethod;
  tax_input_format?: ValueobjectTaxInputFormat;
  tax_method?: ValueobjectTaxMethod;
  to_term?: PresenterOneTermResponse;
  to_term_id?: number;
  updated_at?: string;
}

export interface PresenterExportHistoryResponse {
  created_at?: string;
  created_by?: string;
  file_name?: string;
  id?: number;
  url?: string;
}

export interface PresenterFixedAssetAdjustmentResponse {
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  branch_code?: string;
  calculated_excise_value?: number;
  code?: string;
  created_at?: string;
  id?: number;
  manual_excise_value?: number;
  name?: string;
  name_kana?: string;
  photos?: PresenterPhotoInformation[];
  transition_at?: string;
  urls?: string[];
  usage_started_at?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterFixedAssetAnnualDepreciationResponse {
  accumulated_depreciation_amt_next_period?: number;
  accumulated_over_depreciation_amt?: number;
  asset_biid?: string;
  compare_ledger_setting_id?: number;
  depreciation_amt?: number;
  depreciation_limit_amt?: number;
  ledger_setting_id?: number;
  loss_allowance?: number;
  over_depreciation_amt?: number;
  recognized_amt?: number;
  term?: PresenterOneTermResponse;
  under_depreciation_amt?: number;
}

export interface PresenterFixedAssetBookInformationItem {
  accumulated_depreciation_amount?: number;
  accumulated_impaired_amount?: number;
  book_value?: number;
  date?: string;
  /** Depreciation rate for partial impairment scenarios */
  impair_depreciation_rate?: number;
  ledger_name?: string;
  ledger_setting_id?: number;
}

export interface PresenterFixedAssetBookInformationRequest {
  at: string;
  fixed_asset_ledgers?: PresenterFixedAssetLedgerRequest[];
  intent_action?: string;
}

export interface PresenterFixedAssetBookInformationResponse {
  biid?: string;
  items?: PresenterFixedAssetBookInformationItem[];
}

export interface PresenterFixedAssetBookValueDividingRequest {
  biid: string;
  ledger_book_values?: PresenterLedgerBookValue[];
}

export interface PresenterFixedAssetBookValueDividingResponse {
  biid: string;
  items?: PresenterFixedAssetBookInformationItem[];
}

export interface PresenterFixedAssetDepreResultAdjustHistoryResponse {
  change_situation?: PresenterMasterDataValue;
  valid_from?: string;
}

export interface PresenterFixedAssetDepreciationResponse {
  data?: PresenterDepreciationOfOneYearResponse[];
  terms?: PresenterOneTermResponse[];
}

export interface PresenterFixedAssetFilter {
  "filter[acquire_category]"?: number[];
  "filter[acquire_destination_name]"?: string;
  /** Contains from_date and to_date. If params is omitted, set it to null. If both are omitted, discard this filter. Format: YYYY-MM-DD */
  "filter[acquired_at]"?: string[];
  "filter[acquisition_cost]"?: number[];
  "filter[area_biid]"?: string[];
  "filter[area_codes]"?: string[];
  "filter[asset_category_id]"?: number[];
  "filter[asset_detail_for_corporate_tax]"?: string;
  "filter[asset_status]"?: ValueobjectAssetStatus[];
  "filter[asset_structure_for_corporate_tax]"?: string;
  "filter[asset_type_for_corporate_tax]"?: number[];
  "filter[asset_type_for_depreciable_property_tax]"?: number[];
  "filter[biid]"?: string[];
  "filter[branch_code]"?: string;
  "filter[calculate_cost]"?: boolean;
  "filter[category_codes]"?: string[];
  "filter[change_situation]"?: number;
  "filter[code]"?: string;
  "filter[created_at]"?: string[];
  "filter[department_biid]"?: string[];
  "filter[department_codes]"?: string[];
  "filter[depreciation_method_code]"?: number[];
  "filter[event_type_code]"?: ValueobjectEventTypeCode;
  "filter[exemption_denominator]"?: number;
  "filter[exemption_numerator]"?: number;
  "filter[include_history]"?: boolean;
  "filter[is_get_detail_one_fixed_asset]"?: boolean;
  "filter[is_retroactive]"?: boolean;
  "filter[journal_id]"?: number;
  "filter[keyword]"?: string;
  "filter[memo]"?: string;
  "filter[name]"?: string;
  "filter[name_kana]"?: string;
  "filter[pre_submit_number]"?: string;
  "filter[quantity]"?: number[];
  "filter[service_life]"?: number[];
  "filter[tag]"?: string[];
  "filter[unit_id]"?: number[];
  "filter[usage_started_at]"?: string[];
  "filter[valid_at]"?: string;
  "page[number]"?: number;
  "page[size]"?: number;
  sort?: string[];
}

export interface PresenterFixedAssetLedger {
  accounting_beginning_book_initial_value?: number;
  accumulated_depreciation_amount?: number;
  accumulated_impaired_amount?: number;
  accumulated_over_depreciation_amt?: number;
  acquisition_cost_for_straight_line?: number;
  book_value?: number;
  book_value_after_impairment?: number;
  bulk_equal_installment_depreciation_method?: ValueobjectBulkEqualInstallmentDepreciationMethod;
  created_at?: string;
  depreciated_months?: number;
  depreciation_method?: PresenterMasterDataValue;
  depreciation_method_code?: number;
  dividing_book_value?: number;
  dividing_book_value_standard_date?: string;
  fixed_asset_id?: number;
  gain?: number;
  id?: number;
  impair_depreciation_rate?: number;
  impaired_amount?: number;
  impaired_at?: string;
  ledger_setting?: PresenterOneLedgerSettingResponse;
  ledger_setting_id?: number;
  loss?: number;
  memorandum_value?: number;
  /** optional to keep info about first event ledger */
  original_depreciation_method_code?: number;
  original_residual_amount?: number;
  original_service_life?: number;
  original_usage_period_months?: number;
  remaining_service_life_after_impairment?: number;
  remaining_usage_period_after_impairment?: number;
  residual_amount?: number;
  residual_value_after_impairment?: number;
  retirement_depreciation_ended_method?: ValueobjectRetirementDepreciationEndedMethod;
  revised_acquisition_amount?: number;
  /**
   * @min 0
   * @max 100
   */
  service_life?: number;
  service_life_for_depreciation_calc?: number;
  theoretical_beginning_book_value?: number;
  transition_at?: string;
  transition_beginning_book_value?: number;
  transition_book_value?: number;
  usage_period_months?: number;
}

export interface PresenterFixedAssetLedgerRequest {
  change_situation_code?: ValueobjectChangeSituation;
  depreciation_ended_method?: ValueobjectRetirementDepreciationEndedMethod;
  impair_residual_value?: number;
  impair_service_life?: number;
  impair_usage_period?: number;
  impaired_amount?: number;
  ledger_setting_id?: number;
}

export interface PresenterFixedAssetRanges {
  acquisition_cost?: PresenterMinMax;
}

export interface PresenterFixedAssetsActionStatus {
  adjustable?: boolean;
  /** both itself and its related FAs (dividing) are adjusted */
  adjusted?: boolean;
  biid?: string;
  depr_finished?: boolean;
  divide_related_fas?: string[];
  /** true if FA is divided and one of its dividing siblings is adjusted */
  sibling_adjusted?: boolean;
}

export interface PresenterFixedAssetsActionStatusReq {
  biids?: string[];
  skip_detail?: boolean;
}

export interface PresenterFixedAssetsActionStatusResp {
  action_status?: PresenterFixedAssetsActionStatus[];
}

export interface PresenterFullOneFixedAssetResponse {
  acquire_category?: PresenterMasterDataValue;
  acquire_destination_name?: string;
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  area?: PresenterOneAreaResponse;
  area_biid?: string;
  asset_category?: PresenterOneAssetCategoryResponse;
  asset_detail_for_corporate_tax?: string;
  asset_status?: PresenterMasterDataValue;
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax?: PresenterMasterDataValue;
  asset_type_for_depreciable_property_tax?: PresenterMasterDataValue;
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  branch_code?: string;
  calculated_disposal_excise_value?: number;
  calculated_excise_value?: number;
  calculated_sold_excise_value?: number;
  change_situation?: PresenterMasterDataValue;
  change_situations?: PresenterOneFixedAssetResponse[];
  code?: string;
  /** using for import fixed asset page */
  comment?: string;
  created_at?: string;
  department?: PresenterOneDepartmentResponse;
  department_biid?: string;
  disposal_cost?: number;
  disposal_cost_excluded_excise?: number;
  disposal_destination_name?: string;
  disposal_excise_id?: number;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause?: PresenterOneCauseResponse;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  excise?: PresenterOneExciseResponse;
  excise_id?: number;
  exemption_denominator?: number;
  exemption_numerator?: number;
  fixed_asset_ledgers?: PresenterFixedAssetLedger[];
  fully_impaired?: boolean;
  generating_method?: ValueobjectAGSNSMethod;
  id?: number;
  impaired_at?: string;
  impairment_data?: PresenterImpairmentDataResponse;
  /** used for bulkcreate only */
  index?: number;
  /** used for import from csv only */
  is_error?: boolean;
  is_excluded?: boolean;
  manual_disposal_excise_value?: number;
  manual_excise_value?: number;
  manual_sold_excise_value?: number;
  memo?: string;
  name?: string;
  name_kana?: string;
  net_acquisition_cost?: number;
  photos?: PresenterPhotoInformation[];
  pre_submit_number?: string;
  quantity?: number;
  recognized_at?: string;
  reduced_acquisition_cost?: number;
  reduction_amount?: number;
  retired_at?: string;
  sold_amount?: number;
  sold_amount_excluded_excise?: number;
  sold_at?: string;
  sold_destination_name?: string;
  sold_excise_id?: number;
  subsidy_amount?: number;
  summary_for_asset_depreciation_tax?: string;
  tags?: PresenterOneTagResponse[];
  transition_at?: string;
  unit?: PresenterOneUnitResponse;
  urls?: string[];
  usage_started_at?: string;
  user_info?: PresenterUserInfo;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterGenerateTermRequest {
  default_term_month_date?: 0 | 1 | 2;
  /** @example "2021-03-13" */
  end_date?: string;
  force?: boolean;
  lack_of_month_setting?: 0 | 1;
  /** @example 1 */
  period: number;
  /** @example "2020-03-14" */
  start_date: string;
  total_terms?: number;
  /**
   * @min 1900
   * @max 2999
   * @example 2020
   */
  year: number;
}

export interface PresenterGetCurrentMonthlyClosingResponse {
  closed_at?: string;
  closed_by?: PresenterUserInfo;
  exported_at?: string;
  exported_status?: ValueobjectExportedStatus;
  from_term_month?: PresenterOneFullTermMonthResponse;
  id?: number;
  is_first_monthly_closing?: boolean;
  linked_at?: string;
  linked_status?: ValueobjectLinkedStatus;
  monthly_closing_setting?: PresenterOneMonthlyClosingSettingResponse;
  status?: number;
  to_term_month?: PresenterOneFullTermMonthResponse;
}

export interface PresenterGetPermissionResponse {
  permissions?: ValueobjectPermissionMap;
}

export interface PresenterGetPreviousRecordsRequest {
  ids?: number[];
}

export interface PresenterIDResponse {
  id?: any;
}

export interface PresenterImpairFixedAssetRequest {
  event_attachments?: PresenterAttachmentInformation[];
  event_cause_id?: number;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  impair_residual_value?: number;
  impair_service_life?: number;
  impair_usage_period?: number;
  impaired_amount?: number;
  impaired_at?: string;
  impairment_method?: number;
  is_partial_impairment?: boolean;
}

export interface PresenterImpairmentDataResponse {
  accumulated_impaired_amount?: number;
  book_value_after_impairment?: number;
  book_value_at_impairment?: number;
  depreciation_rate?: number;
  impair_residual_value?: number;
  impair_service_life?: number;
  impair_usage_period?: number;
  impaired_amount?: number;
  impairment_reason?: string;
}

export interface PresenterImportFixedAssetEventRequest {
  event_type_code?: ValueobjectEventTypeCode;
  file_url?: string;
}

export interface PresenterImportStartDateResponse {
  import_start_date?: string;
  last_updated_at?: string;
}

export interface PresenterInitialValueSerialNumberAssetCateResponse {
  asset_category_code?: string;
  asset_category_id?: number;
  asset_category_name?: string;
  initial_value?: number;
  is_editable?: boolean;
}

export interface PresenterInitialValueSerialNumberResponse {
  initial_value?: number;
  is_editable?: boolean;
  is_whole_office?: boolean;
  items?: PresenterInitialValueSerialNumberAssetCateResponse[];
}

export interface PresenterInsertAreaRecordRequest {
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  code?: string;
  id_after?: number;
  id_before?: number;
  name?: string;
  photos?: PresenterPhotoInformation[];
  search_key?: string;
  submit_destination_id?: number;
  urls?: string[];
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterInsertDepartmentRecordRequest {
  biid?: string;
  code?: string;
  id_after?: number;
  id_before?: number;
  name?: string;
  prepress_category_code?: number;
  ref_id?: number;
  search_key?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterInternalUser {
  created_at?: string;
  email?: string;
  id?: number;
  role?: ValueobjectInternalRole;
}

export interface PresenterInternalUserListResponse {
  internal_users?: PresenterInternalUser[];
}

export interface PresenterInternalUserLoginRequest {
  code: string;
  nonce: string;
  redirect_uri: string;
}

export interface PresenterInternalUserLoginResponse {
  csrf_token?: string;
}

export interface PresenterInternalUserUpdateRequest {
  role: ValueobjectInternalRole;
}

export interface PresenterInternalUserUpdateResponse {
  created_at?: string;
  email?: string;
  id?: number;
  role?: ValueobjectInternalRole;
}

export interface PresenterInviteUserRequest {
  id: number;
  /** @minItems 1 */
  role_biids: string[];
}

export interface PresenterIsUsedResponse {
  is_used?: boolean;
}

export interface PresenterJob {
  data?: any;
  id?: string;
  office_id?: number;
  status?: string;
  type?: ValueobjectJobType;
}

export interface PresenterJournalBranchResponse {
  branch_number?: number;
  branch_sides?: PresenterJournalBranchSideResponse[];
  department_code?: string;
  department_name?: string;
  /** IsCutOff is true when remark was truncated (e.g. over 200 chars). Returned as is_cutoffs_remark to frontend. */
  is_cutoffs_remark?: boolean;
  /** only use for acquisition journal */
  memo?: string;
  remark?: string;
  tags?: PresenterOneTagResponse[];
}

export interface PresenterJournalBranchSideResponse {
  account_item?: PresenterAccountItem;
  account_sub_item?: PresenterAccountSubItem;
  calculated_excise_value?: number;
  excise?: PresenterOneShortExciseResponse;
  excise_id?: number;
  excise_value?: number;
  manual_excise_value?: number;
  side?: ValueobjectJournalBranchSide;
  value?: number;
  value_excluded_excise?: number;
  value_included_excise?: number;
}

export interface PresenterJournalImportTargetAccountSettingListItem {
  account_item_code?: string;
  account_item_id?: number;
  account_item_name?: string;
  account_sub_item_code?: string;
  account_sub_item_id?: number;
  account_sub_item_name?: string;
  is_import_target?: boolean;
}

export interface PresenterJournalImportTargetAccountSettingListResponse {
  items?: PresenterJournalImportTargetAccountSettingListItem[];
  last_updated_at?: string;
}

export interface PresenterJournalItemSettingResponse {
  acquisition_credit_payment_category_account_item?: PresenterAccountJournalAccountItemResponse;
  acquisition_credit_payment_category_account_item_id?: number;
  acquisition_credit_payment_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  acquisition_credit_payment_category_account_sub_item_id?: number;
  acquisition_debit_asset_category_account_item?: PresenterAccountJournalAccountItemResponse;
  /** Acquisition - 取得 */
  acquisition_debit_asset_category_account_item_id?: number;
  acquisition_debit_asset_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  acquisition_debit_asset_category_account_sub_item_id?: number;
  acquisition_remark?: string;
  asset_category?: PresenterShortOneAssetCategoryResponse;
  asset_category_id?: number;
  created_at?: number;
  depreciation_credit_accumulated_account_item?: PresenterAccountJournalAccountItemResponse;
  depreciation_credit_accumulated_account_item_id?: number;
  depreciation_credit_accumulated_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  depreciation_credit_accumulated_account_sub_item_id?: number;
  depreciation_credit_asset_category_account_item?: PresenterAccountJournalAccountItemResponse;
  depreciation_credit_asset_category_account_item_id?: number;
  depreciation_credit_asset_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  depreciation_credit_asset_category_account_sub_item_id?: number;
  depreciation_debit_account_item?: PresenterAccountJournalAccountItemResponse;
  /** Depreciation - 減価償却 */
  depreciation_debit_account_item_id?: number;
  depreciation_debit_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  depreciation_debit_account_sub_item_id?: number;
  depreciation_remark?: string;
  from_term_month?: PresenterOneFullTermMonthResponse;
  from_term_month_id?: number;
  id?: number;
  impairment_credit_accumulated_impairment_account_item?: PresenterAccountJournalAccountItemResponse;
  impairment_credit_accumulated_impairment_account_item_id?: number;
  impairment_credit_accumulated_impairment_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  impairment_credit_accumulated_impairment_account_sub_item_id?: number;
  impairment_credit_asset_category_account_item?: PresenterAccountJournalAccountItemResponse;
  impairment_credit_asset_category_account_item_id?: number;
  impairment_credit_asset_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  impairment_credit_asset_category_account_sub_item_id?: number;
  impairment_debit_loss_account_item?: PresenterAccountJournalAccountItemResponse;
  /** Impairment */
  impairment_debit_loss_account_item_id?: number;
  impairment_debit_loss_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  impairment_debit_loss_account_sub_item_id?: number;
  impairment_remark?: string;
  retirement_credit_asset_category_account_item?: PresenterAccountJournalAccountItemResponse;
  retirement_credit_asset_category_account_item_id?: number;
  retirement_credit_asset_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  retirement_credit_asset_category_account_sub_item_id?: number;
  retirement_credit_payment_category_account_item?: PresenterAccountJournalAccountItemResponse;
  retirement_credit_payment_category_account_item_id?: number;
  retirement_credit_payment_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  retirement_credit_payment_category_account_sub_item_id?: number;
  retirement_debit_accumulated_depreciation_account_item?: PresenterAccountJournalAccountItemResponse;
  /** Retirement - 除却 */
  retirement_debit_accumulated_depreciation_account_item_id?: number;
  retirement_debit_accumulated_depreciation_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  retirement_debit_accumulated_depreciation_account_sub_item_id?: number;
  retirement_debit_accumulated_impairment_account_item?: PresenterAccountJournalAccountItemResponse;
  retirement_debit_accumulated_impairment_account_item_id?: number;
  retirement_debit_accumulated_impairment_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  retirement_debit_accumulated_impairment_account_sub_item_id?: number;
  retirement_debit_loss_account_item?: PresenterAccountJournalAccountItemResponse;
  retirement_debit_loss_account_item_id?: number;
  retirement_debit_loss_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  retirement_debit_loss_account_sub_item_id?: number;
  retirement_remark?: string;
  sale_credit_asset_category_account_item?: PresenterAccountJournalAccountItemResponse;
  sale_credit_asset_category_account_item_id?: number;
  sale_credit_asset_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_credit_asset_category_account_sub_item_id?: number;
  sale_credit_gain_account_item?: PresenterAccountJournalAccountItemResponse;
  sale_credit_gain_account_item_id?: number;
  sale_credit_gain_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_credit_gain_account_sub_item_id?: number;
  sale_credit_payment_category_account_item?: PresenterAccountJournalAccountItemResponse;
  sale_credit_payment_category_account_item_id?: number;
  sale_credit_payment_category_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_credit_payment_category_account_sub_item_id?: number;
  sale_debit_accumulated_depreciation_account_item?: PresenterAccountJournalAccountItemResponse;
  /** Sale - 売却 */
  sale_debit_accumulated_depreciation_account_item_id?: number;
  sale_debit_accumulated_depreciation_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_debit_accumulated_depreciation_account_sub_item_id?: number;
  sale_debit_accumulated_impairment_account_item?: PresenterAccountJournalAccountItemResponse;
  sale_debit_accumulated_impairment_account_item_id?: number;
  sale_debit_accumulated_impairment_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_debit_accumulated_impairment_account_sub_item_id?: number;
  sale_debit_loss_account_item?: PresenterAccountJournalAccountItemResponse;
  sale_debit_loss_account_item_id?: number;
  sale_debit_loss_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_debit_loss_account_sub_item_id?: number;
  sale_debit_revenue_account_item?: PresenterAccountJournalAccountItemResponse;
  sale_debit_revenue_account_item_id?: number;
  sale_debit_revenue_account_sub_item?: PresenterAccountJournalAccountSubItemResponse;
  sale_debit_revenue_account_sub_item_id?: number;
  sale_remark?: string;
  to_term_month?: PresenterOneFullTermMonthResponse;
  to_term_month_id?: number;
  updated_at?: number;
}

export interface PresenterJournalLinkageItemResponse {
  error_type?: string;
  journal?: PresenterOneJournalResponse;
  submit_response?: string;
  submit_result?: number;
}

export interface PresenterJournalLinkageResultResponse {
  items?: PresenterJournalLinkageItemResponse[];
  journal_linkage_status?: ValueobjectJournalLinkageStatus;
  monthly_closing?: PresenterMonthlyClosingShortResponse;
  serial_number?: number;
  summary_error_type?: string;
  total_fail?: number;
}

export interface PresenterJournalSettingResponse {
  create_journal_method?: ValueobjectCreateJournalMethod;
  created_at?: string;
  depreciation_journal_cycle_type?: ValueobjectDepreciationJournalCycleType;
  depreciation_journal_method?: ValueobjectDepreciationJournalMethod;
  depreciation_journal_type?: ValueobjectDepreciationJournalType;
  from_term_month?: PresenterOneFullTermMonthResponse;
  from_term_month_id?: number;
  id?: number;
  impairment_journal_cycle_type?: ValueobjectImpairmentJournalCycleType;
  impairment_journal_method?: ValueobjectImpairmentJournalMethod;
  impairment_journal_type?: ValueobjectImpairmentJournalType;
  journal_linkage_status?: ValueobjectJournalLinkageStatus;
  paid_excise_debit_account_item?: PresenterOneShortAccountItemResponse;
  paid_excise_debit_account_item_id?: number;
  received_excise_debit_account_item?: PresenterOneShortAccountItemResponse;
  received_excise_debit_account_item_id?: number;
  slip_date_type?: ValueobjectSlipDateType;
  to_term_month?: PresenterOneFullTermMonthResponse;
  to_term_month_id?: number;
  updated_at?: string;
}

export interface PresenterLedgerBookValue {
  at: string;
  ledger_setting_id: number;
}

export interface PresenterLedgerMemorandumDTO {
  depreciation_method?: ValueobjectDepreciationMethod;
  id?: number;
  memorandum_value?: number;
}

export interface PresenterLedgerSettingFilter {
  "filter[name]"?: string;
  sort?: string[];
}

export interface PresenterMFIDSessionRequest {
  code?: string;
  nonce?: string;
  redirect_uri?: string;
}

export interface PresenterMFIDSessionResponse {
  csrf_token?: string;
}

export interface PresenterMasterDataValue {
  /** @example 10 */
  code?: number;
  key?: string;
  name_en?: string;
  /** @example "any_method" */
  name_jp?: string;
}

export interface PresenterMemorandumRequest {
  asset_type?: number;
  ledgers?: PresenterLedgerMemorandumDTO[];
  quantity?: number;
  unit_id?: number;
}

export interface PresenterMemorandumResponse {
  asset_type?: number;
  ledgers?: PresenterLedgerMemorandumDTO[];
  quantity?: number;
  unit_id?: number;
}

export interface PresenterMinMax {
  max?: number;
  min?: number;
}

export interface PresenterMonthlyClosingHistoryResponse {
  action?: ValueobjectMonthlyClosingAction;
  created_at?: string;
  created_by?: number;
  created_by_user?: PresenterUserInfo;
  from_term_month?: PresenterOneFullTermMonthResponse;
  id?: number;
}

export interface PresenterMonthlyClosingShortResponse {
  from_term_month?: PresenterOneShortTermMonthResponse;
  id?: number;
  to_term_month?: PresenterOneShortTermMonthResponse;
}

export interface PresenterMonthlyDepreciationValues {
  adjust_depreciation_amount?: number;
  ending_book_value?: number;
  original_depreciation_amount?: number;
  term_month_id?: number;
}

export interface PresenterMoveFixedAssetRequest {
  area_biid?: string;
  department_biid?: string;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause_id?: number;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  moved_at?: string;
}

export interface PresenterNavisOfficeExistenceResponse {
  existence?: boolean;
}

export interface PresenterNavisOfficeUserDeletableResponse {
  deletable?: boolean;
  messages?: string[];
}

export interface PresenterNetSuiteSubsidiaryInfo {
  currency_id?: string;
  currency_name?: string;
  currency_symbol?: string;
  id?: string;
  name?: string;
}

export interface PresenterNetsuiteCompanyInformationResponse {
  aa_item_code?: string;
  aa_item_name?: string;
  netsuite_item_code?: string;
  netsuite_item_name?: string;
  sub_items?: PresenterNetsuiteSubItem[];
}

export interface PresenterNetsuiteCredentialRequest {
  account_id: string;
  certificate_id: string;
}

export interface PresenterNetsuiteCredentialResponse {
  account_id?: string;
  certificate_id?: string;
}

export interface PresenterNetsuiteInformationCompanyRequest {
  credential_id?: number;
  currency?: string;
  office_id?: number;
  subsidiary_id?: string;
  subsidiary_name?: string;
}

export interface PresenterNetsuiteInformationCompanyResponse {
  credential_id?: number;
  currency?: string;
  id?: number;
  office_id?: number;
  subsidiary_id?: string;
  subsidiary_name?: string;
}

export interface PresenterNetsuiteKeyResponse {
  certificate?: string;
}

export type PresenterNetsuiteRevokeCredentialResponse = object;

export interface PresenterNetsuiteStatusResponse {
  account_id?: string;
  is_linked?: boolean;
  linked_date?: string;
  subsidiary_id?: string;
  subsidiary_name?: string;
}

export interface PresenterNetsuiteSubItem {
  aa_sub_item_code?: string;
  aa_sub_item_name?: string;
  netsuite_sub_item_code?: string;
  netsuite_sub_item_name?: string;
}

export interface PresenterNetsuiteSubsidiariesResponse {
  items?: PresenterNetSuiteSubsidiaryInfo[];
}

export interface PresenterNumJournalsOfType {
  acquisition?: number;
  depreciation?: number;
  impairment?: number;
  retirement?: number;
  sold?: number;
}

export interface PresenterOfficeUserRole {
  id?: number;
  office_user_id?: number;
  role?: PresenterOneRoleResponse;
  role_biid?: string;
}

export interface PresenterOfficesUsersResponse {
  created_at?: string;
  display_name?: string;
  id?: number;
  is_active?: boolean;
  office?: PresenterAAOffice;
  roles?: PresenterOfficeUserRole[];
  updated_at?: string;
  user?: PresenterAAUser;
}

export interface PresenterOneAccPlusDeptResponse {
  ancestry?: string;
  code?: string;
  disp_order?: number;
  id?: number;
  memo?: string;
  name?: string;
}

export interface PresenterOneAccountItemResponse {
  account_sub_items?: PresenterOneAccountSubItemResponse[];
  ca_web_item_id?: number;
  code?: string;
  excise?: PresenterOneShortExciseResponse;
  id?: number;
  is_active?: boolean;
  name?: string;
  search_key?: string;
  smb_item_id?: number;
}

export interface PresenterOneAccountSubItemResponse {
  ca_web_sub_item_id?: number;
  code?: string;
  excise?: PresenterOneShortExciseResponse;
  id?: number;
  is_active?: boolean;
  name?: string;
  search_key?: string;
  smb_sub_item_id?: number;
}

export interface PresenterOneAreaResponse {
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  code?: string;
  created_at?: string;
  created_by?: number;
  id?: number;
  name?: string;
  office_id?: number;
  photos?: PresenterPhotoInformation[];
  search_key?: string;
  submit_destination?: PresenterOneShortSubmitDestinationResponse;
  urls?: string[];
  user_info?: PresenterUserInfo;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterOneAssetCategoryResponse {
  asset_detail_for_corporate_tax?: string;
  asset_structure_for_corporate_tax?: string;
  asset_type?: ValueobjectAssetType;
  asset_type_for_corporate_tax?: PresenterMasterDataValue;
  asset_type_for_depreciable_property_tax?: PresenterMasterDataValue;
  code?: string;
  created_at?: string;
  created_by?: number;
  depreciation_method?: PresenterMasterDataValue;
  excise?: PresenterOneExciseResponse;
  excise_id?: number;
  id?: number;
  name?: string;
  office_id?: number;
  search_key?: string;
  service_life?: number;
  updated_at?: string;
  updated_by?: number;
  user_info?: PresenterUserInfo;
}

export interface PresenterOneAssetReportCostResponse {
  accounting_current_book_value?: number;
  accounting_current_book_value_v2?: number;
  accounting_previous_book_value?: number;
  accounting_previous_book_value_v2?: number;
  accumulated_depreciation_amount?: number;
  accumulated_impaired_amount?: number;
  acquisition_cost?: number;
  decreases?: PresenterOneIncreaseDecreaseCostResponse[];
  depreciation_amount?: number;
  impaired_amount?: number;
  increases?: PresenterOneIncreaseDecreaseCostResponse[];
  reduction_amount?: number;
}

export interface PresenterOneAutoGeneratingSerialNumberSettingResponse {
  created_at?: string;
  created_by?: number;
  from_term?: PresenterOneShortTermResponse;
  from_term_id?: number;
  generating_method?: ValueobjectAGSNSMethod;
  generating_scope?: ValueobjectAGSNSScope;
  id?: number;
  length_rule?: ValueobjectAGSNSLength;
  rules?: {
    field?: ValueobjectAGSNSField;
    value?: any;
  }[];
  to_term?: PresenterOneShortTermResponse;
  to_term_id?: number;
  updated_at?: string;
  updated_by?: number;
}

export interface PresenterOneCauseResponse {
  code?: string;
  content?: string;
  id?: number;
  is_default?: boolean;
  search_key?: string;
  type?: number;
}

export interface PresenterOneCreatableOfficeResponse {
  id?: number;
  identification_code?: string;
  is_exist?: boolean;
  name?: string;
  tenant_type?: string;
  /** These fields use when office in UserResponse struct, represent UserDisplayName, UserFamilyName, UserGivenName */
  user_display_name?: string;
  user_family_name?: string;
  user_given_name?: string;
  /** This field use when office in UserResponse struct, represent that user is activated in this office or not */
  user_is_activated_in?: boolean;
}

export interface PresenterOneDepartmentResponse {
  biid?: string;
  code?: string;
  created_at?: string;
  created_by?: number;
  created_by_name?: string;
  id?: number;
  name?: string;
  office_id?: number;
  prepress_category?: PresenterMasterDataValue;
  ref_code?: string;
  ref_id?: number;
  ref_name?: string;
  search_key?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterOneDepreciationRateResponse {
  depreciation_method?: number;
  depreciation_rate?: number;
  guarantee_rate?: number;
  id?: number;
  memo?: string;
  revised_depreciation_rate?: number;
  service_life?: number;
}

export interface PresenterOneExciseRateResponse {
  end_date?: string;
  id?: number;
  rate?: number;
  reduced_flg?: number;
  start_date?: string;
  total_percentage?: number;
}

export interface PresenterOneExciseResponse {
  code?: string;
  disp_order?: number;
  excise_label?: PresenterOneShortExciseLabelResponse;
  excise_master_id?: number;
  excise_rate?: PresenterOneExciseRateResponse;
  external_code?: string;
  id?: number;
  is_active?: boolean;
  long_name?: string;
  search_key?: string;
  short_name?: string;
  simple_excise?: PresenterOneSimpleExciseResponse;
  tmp_visible_flg?: boolean;
}

export interface PresenterOneExportJournalHistoryResponse {
  created_at?: string;
  file_name?: string;
  id?: number;
  monthly_closing?: PresenterMonthlyClosingShortResponse;
  serial_number?: number;
  total_fail?: number;
  user_info?: PresenterUserInfo;
}

export interface PresenterOneFixedAssetCommentCountResponse {
  count?: number;
  fixed_asset_biid?: string;
}

export interface PresenterOneFixedAssetCommentResponse {
  content?: string;
  created_at?: string;
  created_by?: number;
  fixed_asset_biid?: string;
  id?: number;
  updated_at?: string;
  user_info?: PresenterUserInfo;
}

export interface PresenterOneFixedAssetCostResponse {
  accounting_current_book_value?: number;
  accumulated_depreciation_amount?: number;
  depreciation_amount?: number;
  ledger_id?: number;
  ledger_setting_id?: number;
}

export interface PresenterOneFixedAssetHistoryResponse {
  accumulated_impaired_amount?: number;
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  acquisition_cost_included_excise?: number;
  area?: PresenterShortOneAreaWithSubmitDestinationResponse;
  asset_category?: PresenterShortOneAssetCategoryResponse;
  asset_status?: PresenterMasterDataValue;
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  branch_code?: string;
  calculated_disposal_excise_value?: number;
  calculated_excise_value?: number;
  calculated_sold_excise_value?: number;
  change_situation?: PresenterMasterDataValue;
  change_situations?: PresenterOneFixedAssetHistoryResponse[];
  code?: string;
  created_at?: string;
  deleted_at?: string;
  department?: PresenterShortOneDepartmentResponse;
  disposal_cost?: number;
  disposal_cost_excluded_excise?: number;
  disposal_cost_included_excise?: number;
  disposal_destination_name?: string;
  disposal_excise_id?: number;
  disposal_excise_value?: number;
  divided_at?: string;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause?: PresenterOneCauseResponse;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  excise_id?: number;
  excise_value?: number;
  fixed_asset_ledgers?: PresenterFixedAssetLedger[];
  id?: number;
  impair_residual_value?: number;
  impair_service_life?: number;
  impair_usage_period?: number;
  impaired_amount?: number;
  impaired_at?: string;
  is_exported?: boolean;
  is_linked?: boolean;
  manual_disposal_excise_value?: number;
  manual_excise_value?: number;
  manual_sold_excise_value?: number;
  name?: string;
  name_kana?: string;
  photos?: PresenterPhotoInformation[];
  quantity?: number;
  recognized_at?: string;
  reduction_amount?: number;
  remaining_book_value?: number;
  retired_at?: string;
  sold_amount?: number;
  sold_amount_excluded_excise?: number;
  sold_amount_included_excise?: number;
  sold_at?: string;
  sold_destination_name?: string;
  sold_excise_id?: number;
  sold_excise_value?: number;
  subsidy_amount?: number;
  tags?: PresenterOneTagResponse[];
  term_month?: PresenterOneShortTermMonthResponse;
  transition_at?: string;
  urls?: string[];
  usage_started_at?: string;
  user_info?: PresenterUserInfo;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterOneFixedAssetOperationLogResponse {
  after_id?: number;
  before_id?: number;
  cached_fixed_asset_biid?: string;
  cached_fixed_asset_branch_code?: string;
  cached_fixed_asset_code?: string;
  cached_fixed_asset_name?: string;
  created_at?: string;
  id?: number;
  office_user?: PresenterUserInfo;
  operation_target?: ValueobjectOperationTarget;
  operation_type?: ValueobjectOperationType;
}

export interface PresenterOneFixedAssetResponse {
  acquire_category?: PresenterMasterDataValue;
  acquire_destination_name?: string;
  acquired_at?: string;
  acquisition_cost?: number;
  acquisition_cost_excluded_excise?: number;
  area?: PresenterShortOneAreaResponse;
  area_biid?: string;
  asset_category?: PresenterShortOneAssetCategoryResponse;
  asset_detail_for_corporate_tax?: string;
  asset_status?: PresenterMasterDataValue;
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax?: PresenterMasterDataValue;
  asset_type_for_depreciable_property_tax?: PresenterMasterDataValue;
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  branch_code?: string;
  calculated_disposal_excise_value?: number;
  calculated_excise_value?: number;
  calculated_sold_excise_value?: number;
  change_situation?: PresenterMasterDataValue;
  change_situations?: PresenterOneFixedAssetResponse[];
  code?: string;
  created_at?: string;
  department?: PresenterShortOneDepartmentResponse;
  department_biid?: string;
  disposal_cost?: number;
  disposal_cost_excluded_excise?: number;
  disposal_destination_name?: string;
  disposal_excise_id?: number;
  divided_at?: string;
  dividing_destination_fixed_asset?: PresenterOneFixedAssetResponse;
  dividing_source_fixed_asset?: PresenterOneFixedAssetResponse;
  dividing_source_id?: number;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause?: PresenterOneCauseResponse;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  excise_id?: number;
  exemption_denominator?: number;
  exemption_numerator?: number;
  fixed_asset_costs?: PresenterOneFixedAssetCostResponse[];
  fixed_asset_ledgers?: PresenterFixedAssetLedger[];
  id?: number;
  impair_residual_value?: number;
  impair_service_life?: number;
  impair_usage_period?: number;
  impaired_amount?: number;
  impaired_at?: string;
  impairment_data?: PresenterImpairmentDataResponse;
  is_excluded?: boolean;
  manual_disposal_excise_value?: number;
  manual_excise_value?: number;
  manual_sold_excise_value?: number;
  memo?: string;
  name?: string;
  name_kana?: string;
  photos?: PresenterPhotoInformation[];
  pre_submit_number?: string;
  quantity?: number;
  recognized_at?: string;
  reduction_amount?: number;
  retired_at?: string;
  sold_amount?: number;
  sold_amount_excluded_excise?: number;
  sold_at?: string;
  sold_destination_name?: string;
  sold_excise_id?: number;
  summary_for_asset_depreciation_tax?: string;
  tags?: PresenterOneTagResponse[];
  transition_at?: string;
  unit?: PresenterShortOneUnitResponse;
  urls?: string[];
  usage_started_at?: string;
  user_info?: PresenterUserInfo;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterOneFullTermMonthResponse {
  end_date?: string;
  half_term?: number;
  id?: number;
  month?: number;
  month_serial_number?: number;
  quarter?: number;
  start_date?: string;
  term?: PresenterOneShortTermResponse;
  term_id?: number;
  year?: number;
}

export interface PresenterOneIncreaseDecreaseCostResponse {
  change_situation_code?: ValueobjectChangeSituation;
  value?: number;
}

export interface PresenterOneJournalResponse {
  branches?: PresenterJournalBranchResponse[];
  id?: number;
  is_closing?: boolean;
  is_reversed_journal?: boolean;
  journal_event_type?: ValueobjectJournalEventType;
  journal_linkage_key?: string;
  memo?: string;
  recognized_at?: string;
  slip_number?: number;
  term_id?: number;
  term_month_id?: number;
  unique_fa_biid?: string;
}

export interface PresenterOneLedgerSettingResponse {
  accounting_journal_target?: boolean;
  bulk_equal_installment_depreciation_method?: ValueobjectBulkEqualInstallmentDepreciationMethod;
  bulk_equal_installment_first_year_method?: ValueobjectBulkEqualInstallmentFirstYearMethod;
  created_at?: string;
  created_by?: number;
  five_years_equal_installment_rounding_method?: ValueobjectFiveYearsEqualInstallmentRoundingMethod;
  id?: number;
  impairment_loss_apply_method?: ValueobjectImpairmentLossApplyMethod;
  ledger_purpose?: ValueobjectLedgerPurpose;
  lump_sum_depreciable_asset_rounding_on?: ValueobjectLumpSumDepreciableAssetRoundingOn;
  maximum_depreciation_reached_year_calculation_method?: ValueobjectMaximumDepreciationReachedYearCalculationMethod;
  monthly_residual_method?: ValueobjectMonthlyResidualMethod;
  movement_depreciation_amount_method?: ValueobjectMovementDepreciationAmountMethod;
  name?: string;
  retirement_depreciation_ended_method?: ValueobjectRetirementDepreciationEndedMethod;
  /** Depreciation setting */
  rounding_method?: NumRoundingMethod;
  updated_at?: string;
  updated_by?: number;
}

export interface PresenterOneLoggedinLogResponse {
  created_at?: string;
  id?: number;
  office_user?: PresenterUserInfo;
  remote_addr?: string;
}

export interface PresenterOneMasterDataResponse {
  /**
   * ID     uint64             `json:"id"` // Currently, we don't need this field
   * @example "depreciation_method"
   */
  name?: string;
  name_jp?: string;
  submit_destination_cities?: PresenterCityCode[];
  submit_destination_districts?: PresenterDistrictCode[];
  values?: PresenterMasterDataValue[];
}

export interface PresenterOneMonthlyClosingResponse {
  closed_at?: string;
  closed_by?: PresenterUserInfo;
  exported_at?: string;
  exported_status?: ValueobjectExportedStatus;
  from_term_month?: PresenterOneFullTermMonthResponse;
  id?: number;
  linked_at?: string;
  linked_status?: ValueobjectLinkedStatus;
  monthly_closing_setting?: PresenterOneMonthlyClosingSettingResponse;
  status?: number;
  to_term_month?: PresenterOneFullTermMonthResponse;
}

export interface PresenterOneMonthlyClosingSettingResponse {
  closing_cycle?: ValueobjectMonthlyClosingCycle;
  id?: number;
  term?: PresenterOneTermResponse;
}

export interface PresenterOneOfficeResponse {
  id?: number;
  identification_code?: string;
  name?: string;
  tenant_type?: string;
  /** These fields use when office in UserResponse struct, represent UserDisplayName, UserFamilyName, UserGivenName */
  user_display_name?: string;
  user_family_name?: string;
  user_given_name?: string;
  /** This field use when office in UserResponse struct, represent that user is activated in this office or not */
  user_is_activated_in?: boolean;
}

export interface PresenterOneOfficeUserResponse {
  display_name?: string;
  email?: string;
  family_name?: string;
  given_name?: string;
  id?: number;
  is_active?: boolean;
  is_suspended?: boolean;
  office_id?: number;
  roles?: PresenterOneRoleResponse[];
  user_id?: number;
}

export interface PresenterOnePermission {
  choices?: PresenterChoices;
  feature_id?: ValueobjectFID;
  feature_name_en?: string;
  feature_name_jp?: string;
}

export interface PresenterOnePermissionCategory {
  category_id?: number;
  category_name_en?: string;
  category_name_jp?: string;
  is_default?: boolean;
  permissions?: PresenterOnePermission[];
}

export interface PresenterOnePreviousFixedAssetEventResponse {
  area_biid?: string;
  biid?: string;
  id?: number;
  previous?: PresenterOnePreviousFixedAssetResponse;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterOnePreviousFixedAssetResponse {
  area?: PresenterOneAreaResponse;
  area_biid?: string;
  asset_category?: PresenterShortOneAssetCategoryResponse;
  biid?: string;
  department?: PresenterShortOneDepartmentResponse;
  event_cause?: PresenterOneCauseResponse;
  id?: number;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterOneReportAssetCategoryAmount {
  amount?: PresenterOneAssetReportCostResponse;
  asset_category_code?: string;
  asset_category_name?: string;
  items?: PresenterReportAssetAmount[];
}

export interface PresenterOneReportCostResponse {
  amount?: PresenterOneAssetReportCostResponse;
  items?: PresenterOneReportAssetCategoryAmount[];
  type?: string;
}

export interface PresenterOneRoleResponse {
  biid?: string;
  categories?: PresenterOnePermissionCategory[];
  created_at?: string;
  created_by?: number;
  deletable?: boolean;
  disp_order?: number;
  editable?: boolean;
  id?: number;
  name?: string;
}

export interface PresenterOneShortAccountItemResponse {
  code?: string;
  id?: number;
  is_active?: boolean;
  name?: string;
  search_key?: string;
}

export interface PresenterOneShortExciseLabelResponse {
  abbreviation?: string;
  id?: number;
  name?: string;
}

export interface PresenterOneShortExciseResponse {
  code?: string;
  excise_label?: PresenterOneShortExciseLabelResponse;
  excise_master_id?: number;
  external_code?: string;
  id?: number;
  long_name?: string;
  search_key?: string;
  short_name?: string;
}

export interface PresenterOneShortSubmitDestinationResponse {
  code?: string;
  id?: number;
  name?: string;
  search_key?: string;
}

export interface PresenterOneShortTermMonthResponse {
  end_date?: string;
  id?: number;
  month?: number;
  start_date?: string;
  term?: PresenterOneShortTermResponse;
  term_id?: number;
  year?: number;
}

export interface PresenterOneShortTermResponse {
  end_date?: string;
  id?: number;
  period?: number;
  start_date?: string;
  year?: number;
}

export interface PresenterOneSimpleExciseResponse {
  id?: number;
  name?: string;
  rate?: number;
}

export interface PresenterOneSubmitDestinationResponse {
  apply_destination?: string;
  asset_location_1?: string;
  asset_location_2?: string;
  asset_location_3?: string;
  capital_amount?: number;
  city_code?: string;
  code?: string;
  commercial_name?: string;
  company_established_at_month?: number;
  company_established_at_year?: number;
  company_name?: string;
  company_name_kana?: string;
  corporate_code?: string;
  created_at?: string;
  created_by?: number;
  details_export_setting?: number;
  district_code?: string;
  has_additional_depreciation_report?: boolean;
  has_approval_of_shortened_service_life?: boolean;
  has_blue_return?: boolean;
  has_borrow_asset?: boolean;
  has_depreciation_method_on_ta_for_dbm?: boolean;
  has_depreciation_method_on_ta_for_slm?: boolean;
  has_non_taxable_asset?: boolean;
  has_special_depreciation_or_compress_entry?: boolean;
  has_taxation_standard_special?: boolean;
  id?: number;
  industry_category?: string;
  lender_name?: string;
  name?: string;
  office_id?: number;
  owner_address?: string;
  owner_address_kana?: string;
  owner_category_of_building_of_company_rented_house?: boolean;
  owner_category_of_building_of_company_self_owned?: boolean;
  owner_code?: string;
  owner_telephone?: string;
  owner_zip_code?: string;
  person_in_charge_department?: string;
  person_in_charge_name?: string;
  person_in_charge_telephone?: string;
  remark?: string;
  representative_name?: string;
  representative_name_kana?: string;
  representative_position?: string;
  search_key?: string;
  tax_accountant_name?: string;
  tax_accountant_telephone?: string;
  updated_at?: string;
  updated_by?: number;
  user_info?: PresenterUserInfo;
}

export interface PresenterOneTagResponse {
  id?: string;
  name?: string;
  position?: number;
}

export interface PresenterOneTermMonthResponse {
  end_date?: string;
  fiscal_year?: PresenterOneShortTermResponse;
  half_term?: number;
  id?: number;
  month?: number;
  month_serial_number?: number;
  quarter?: number;
  start_date?: string;
  term_id?: number;
  year?: number;
}

export interface PresenterOneTermPagingResponse {
  from_term_month?: PresenterOneTermMonthResponse;
  to_term_month?: PresenterOneTermMonthResponse;
}

export interface PresenterOneTermResponse {
  end_date?: string;
  id?: number;
  lack_of_month_setting?: ValueobjectLackOfMonthSetting;
  period?: number;
  start_date?: string;
  term_months?: PresenterOneTermMonthResponse[];
  year?: number;
}

export interface PresenterOneUnitResponse {
  id?: number;
  is_active?: boolean;
  is_default?: boolean;
  link_memorandum_value_quantity?: boolean;
  name?: string;
  position?: number;
}

export interface PresenterPaging {
  "page[number]"?: number;
  "page[size]"?: number;
}

export interface PresenterPayAsYouGoCurrentMonth {
  asset_count?: number;
  is_confirmed?: boolean;
  period_month?: number;
  period_year?: number;
  user_count?: number;
}

export interface PresenterPayAsYouGoHistorical {
  asset_count?: number;
  confirmed_at?: string;
  is_confirmed?: boolean;
  period_month?: number;
  period_year?: number;
  user_count?: number;
}

export interface PresenterPayAsYouGoUsageResponse {
  current_month?: PresenterPayAsYouGoCurrentMonth;
  historical?: PresenterPayAsYouGoHistorical[];
}

export interface PresenterPhotoInformation {
  filename?: string;
  id: string;
  thumbnail_url?: string;
  url?: string;
}

export interface PresenterPreFillAllocationInput {
  amount: number;
  side_id: number;
}

export interface PresenterPreFillDraftAssetRequest {
  /** @minItems 1 */
  allocations: PresenterPreFillAllocationInput[];
}

export interface PresenterPreFillDraftAssetResponse {
  acquisition_cost_excluded_excise?: number;
  acquisition_cost_included_excise?: number;
  department_biid?: string;
  department_name?: string;
  excise_id?: number;
  excise_value?: number;
  memo?: string;
  urls?: string[];
}

export interface PresenterProposedNewCategory {
  alternative_matches?: PresenterProposedNewCategoryItem[];
  asset_category_name?: string;
  confidence?: number;
  logic_path?: string;
  nta_link?: string;
  service_life?: number;
}

export interface PresenterProposedNewCategoryItem {
  asset_category_name?: string;
  confidence?: number;
  logic_path?: string;
  nta_link?: string;
  service_life?: number;
}

export interface PresenterReopenMonthlyClosingRequest {
  dry_run?: boolean;
}

export interface PresenterReopenMonthlyClosingResponse {
  from_term_month?: PresenterOneFullTermMonthResponse;
  id?: number;
  retroactive_fixedasset_count?: number;
  to_term_month?: PresenterOneFullTermMonthResponse;
}

export interface PresenterReportAssetAmount {
  amount?: PresenterOneAssetReportCostResponse;
  biid?: string;
  branch_code?: string;
  code?: string;
  is_deleted?: boolean;
  name?: string;
}

export interface PresenterReportCostResponse {
  items?: PresenterOneReportCostResponse[];
  ledger_setting?: PresenterOneLedgerSettingResponse;
  term_months?: PresenterOneTermMonthResponse[];
  year?: number;
}

export interface PresenterReselectMonthlyClosingRequest {
  term_month_id: number;
}

export interface PresenterResponse {
  data?: any;
  errors?: PresenterError[];
  meta?: any;
}

export interface PresenterRetireFixedAssetRequest {
  calculated_disposal_excise_value?: number;
  disposal_cost?: number;
  disposal_cost_excluded_excise?: number;
  disposal_destination_name?: string;
  disposal_excise_id?: number;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause_id?: number;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  manual_disposal_excise_value?: number;
  retired_at?: string;
  retirement_fixed_asset_ledger_requests?: PresenterRetirementFixedAssetLedgerRequest[];
}

export interface PresenterRetirementFixedAssetLedgerRequest {
  ledger_setting_id?: number;
  /** Because I changed the DTO and the Presenter is using the copy method so that I need keep DepreciationEndedMethod name */
  retirement_depreciation_ended_method?: ValueobjectRetirementDepreciationEndedMethod;
}

export interface PresenterReverseAllocateResult {
  allocation_id?: number;
  new_allocated?: number;
  new_remaining?: number;
  side_id?: number;
}

export interface PresenterRoleListResponse {
  biid?: string;
  id?: number;
  name?: string;
}

export interface PresenterSSOSessionRequest {
  code: string;
  nonce: string;
  redirect_uri: string;
  tenant_uid: number;
}

export interface PresenterSaveAutoGeneratingSerialNumberSettingRequest {
  from_term_id: number;
  generating_method?: ValueobjectAGSNSMethod;
  generating_scope?: ValueobjectAGSNSScope;
  length_rule?: ValueobjectAGSNSLength;
  rules?: {
    field?: ValueobjectAGSNSField;
    value: any;
  }[];
}

export interface PresenterSaveExciseSettingRequest {
  automatic_journal_entry_accquisition_type: ValueobjectAutomaticJournalEntryAccquisitionType;
  can_edit_tax?: ValueobjectEditTax;
  default_excise_disposal_cost_id?: number;
  default_excise_sell_id?: number;
  from_term_id: number;
  input_tax_when_register_fixed_asset: ValueobjectInputTaxWhenRegisterFixedAsset;
  rounding_method?: NumRoundingMethod;
  tax_input_format?: ValueobjectTaxInputFormat;
  tax_method: ValueobjectTaxMethod;
}

export interface PresenterSaveImportStartDateRequest {
  import_start_date: string;
}

export interface PresenterSaveInitialValuesSerialNumberRequest {
  asset_category_initial_values?: {
    id: number;
    /** @min 1 */
    initial_value: number;
  }[];
  /** @min 1 */
  whole_office?: number;
}

export interface PresenterSaveJournalImportTargetAccountSettingItem {
  account_item_id: number;
  account_sub_item_id?: number;
}

export interface PresenterSaveJournalImportTargetAccountSettingRequest {
  items: PresenterSaveJournalImportTargetAccountSettingItem[];
}

export interface PresenterSaveLedgerSettingRequest {
  dry_run?: boolean;
  items: PresenterSaveLedgerSettingRequestItem[];
}

export interface PresenterSaveLedgerSettingRequestItem {
  bulk_equal_installment_depreciation_method?: ValueobjectBulkEqualInstallmentDepreciationMethod;
  bulk_equal_installment_first_year_method?: ValueobjectBulkEqualInstallmentFirstYearMethod;
  deleted?: boolean;
  five_years_equal_installment_rounding_method?: ValueobjectFiveYearsEqualInstallmentRoundingMethod;
  id?: number;
  impairment_loss_apply_method?: ValueobjectImpairmentLossApplyMethod;
  ledger_purpose?: ValueobjectLedgerPurpose;
  lump_sum_depreciable_asset_rounding_on?: ValueobjectLumpSumDepreciableAssetRoundingOn;
  maximum_depreciation_reached_year_calculation_method?: ValueobjectMaximumDepreciationReachedYearCalculationMethod;
  monthly_residual_method?: ValueobjectMonthlyResidualMethod;
  movement_depreciation_amount_method?: ValueobjectMovementDepreciationAmountMethod;
  /** @maxLength 20 */
  name: string;
  retirement_depreciation_ended_method?: ValueobjectRetirementDepreciationEndedMethod;
  /** Depreciation setting */
  rounding_method?: NumRoundingMethod;
}

export interface PresenterSaveRoleRequest {
  categories?: PresenterOnePermissionCategory[];
  name?: string;
}

export interface PresenterSellFixedAssetRequest {
  calculated_disposal_excise_value?: number;
  calculated_sold_excise_value?: number;
  disposal_cost?: number;
  disposal_cost_excluded_excise?: number;
  disposal_destination_name?: string;
  disposal_excise_id?: number;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause_id?: number;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  manual_disposal_excise_value?: number;
  manual_sold_excise_value?: number;
  retirement_fixed_asset_ledger_requests?: PresenterRetirementFixedAssetLedgerRequest[];
  sold_amount?: number;
  sold_amount_excluded_excise?: number;
  sold_at?: string;
  sold_destination_name?: string;
  sold_excise_id?: number;
}

export interface PresenterShortOneAreaResponse {
  biid?: string;
  code?: string;
  id?: number;
  name?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterShortOneAreaWithSubmitDestinationResponse {
  biid?: string;
  code?: string;
  id?: number;
  name?: string;
  submit_destination?: PresenterOneShortSubmitDestinationResponse;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterShortOneAssetCategoryResponse {
  asset_type?: ValueobjectAssetType;
  code?: string;
  id?: number;
  name?: string;
}

export interface PresenterShortOneDepartmentResponse {
  biid?: string;
  code?: string;
  id?: number;
  name?: string;
  ref_code?: string;
  ref_id?: number;
  ref_name?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterShortOneUnitResponse {
  id?: number;
  is_active?: boolean;
  is_default?: boolean;
  link_memorandum_value_quantity?: boolean;
  name?: string;
}

export interface PresenterSource {
  parameter?: string;
  pointer?: string;
}

export interface PresenterStartUsageFixedAssetRequest {
  dry_run?: boolean;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause_id?: number;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  usage_started_at?: string;
}

export interface PresenterSuggestAssetCategoryRequest {
  asset_code?: string;
  asset_name?: string;
  file_id?: string;
}

export interface PresenterSuggestAssetCategoryResponse {
  alternative_matches?: PresenterAlternativeMatch[];
  asset_category_code?: string;
  asset_category_name?: string;
  confidence?: number;
  correlation_id?: string;
  proposed_new_category?: PresenterProposedNewCategory;
  reasoning?: string;
  service_life?: number;
}

export interface PresenterSummaryFixedAssetEvent {
  code?: number;
  total?: number;
}

export interface PresenterSusJournalListResponse {
  last_fetched_at?: string;
  sides?: PresenterSusJournalListSide[];
}

export interface PresenterSusJournalListSide {
  account_code?: string;
  account_item_id?: number;
  account_name?: string;
  account_sub_item_id?: number;
  allocated_value?: number;
  business_partner_id?: number;
  dept_code?: string;
  dept_id?: number;
  dept_name?: string;
  excise_id?: number;
  excise_value?: number;
  fully_processed_at?: string;
  fully_processed_term_month_end_date?: string;
  id?: number;
  invoice_kind?: string;
  journal_number?: number;
  journal_type?: string;
  memo?: string;
  project_biid?: string;
  recognized_at?: string;
  remark?: string;
  side_type?: number;
  sub_account_code?: string;
  sub_account_name?: string;
  unallocated_value?: number;
  value?: number;
}

export interface PresenterSusJournalRefreshResponse {
  deleted_count?: number;
  fetch_start?: string;
  fetched?: number;
  incremental?: boolean;
  kept_after_filter?: number;
  last_fetched_at?: string;
  needs_review_count?: number;
  new_count?: number;
  overwritten_count?: number;
  pages_fetched?: number;
  reason?: string;
  status?: string;
}

export interface PresenterSwitchAssetCategoryRequest {
  asset_category_id?: number;
  asset_detail_for_corporate_tax?: string;
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  event_attachments?: PresenterAttachmentInformation[];
  event_cause_id?: number;
  event_photos?: PresenterPhotoInformation[];
  event_urls?: string[];
  switched_at?: string;
}

export interface PresenterSwitchOfficeRequest {
  office_id?: number;
}

export interface PresenterTaxDeclarationDecreaseResponse {
  fixed_assets?: PresenterTaxDeclarationFixedAssetDecrease[];
  sub_total?: number;
  submit_destination?: PresenterTaxDeclarationSubmitDestination;
  total?: number;
}

export interface PresenterTaxDeclarationExportReportResponse {
  uuid?: string;
}

export interface PresenterTaxDeclarationFixedAssetDecrease {
  acquired_at?: string;
  acquisition_cost?: number;
  asset_type_for_depreciable_property_tax_code?: ValueobjectAssetTypeForDepreciablePropertyTaxCode;
  biid?: string;
  branch_code?: string;
  cause?: ValueobjectTaxDeclarationDecreaseCause;
  code?: string;
  depreciation_residual_rate?: string;
  name?: string;
  name_kana?: string;
  quantity?: number;
  residual_amount?: string[];
  /** use for depreciation method depreciating by year */
  service_life?: number;
  special_rate?: string;
  tax_standard_amount?: string[];
  type?: ValueobjectTaxDeclarationDecreaseType;
  /** use for depreciation method depreciating by month */
  usage_period_months?: number;
}

export interface PresenterTaxDeclarationFixedAssetIncrease {
  acquired_at?: string;
  acquisition_cost?: number;
  asset_type_for_depreciable_property_tax_code?: ValueobjectAssetTypeForDepreciablePropertyTaxCode;
  biid?: string;
  branch_code?: string;
  cause?: ValueobjectTaxDeclarationIncreaseCause;
  code?: string;
  depreciation_residual_rate?: string;
  name?: string;
  name_kana?: string;
  quantity?: number;
  residual_amount?: string[];
  /** use for depreciation method depreciating by year */
  service_life?: number;
  special_rate?: string;
  tax_standard_amount?: string[];
  /** use for depreciation method depreciating by month */
  usage_period_months?: number;
}

export interface PresenterTaxDeclarationIncreaseResponse {
  fixed_assets?: PresenterTaxDeclarationFixedAssetIncrease[];
  mode?: ValueobjectTaxDeclarationMode;
  sub_total?: number;
  submit_destination?: PresenterTaxDeclarationSubmitDestination;
  /** only visible in case filter for last page */
  total?: number;
}

export interface PresenterTaxDeclarationResponse {
  apply_destination?: string;
  submit_destination_code?: string;
  submit_destination_id?: number;
  submit_destination_name?: string;
  total_export?: number;
}

export interface PresenterTaxDeclarationSubmitDestination {
  apply_destination?: string;
  /** part 15 */
  asset_location_1?: string;
  asset_location_2?: string;
  asset_location_3?: string;
  capital_amount?: number;
  code?: string;
  commercial_name?: string;
  /** part 5 */
  company_established_at_month?: number;
  company_established_at_year?: number;
  /** part 2 */
  company_name?: string;
  company_name_kana?: string;
  /** part 3 */
  corporate_code?: string;
  /** part 9 */
  has_additional_depreciation_report?: boolean;
  /** part 8 */
  has_approval_of_shortened_service_life?: boolean;
  /** part 14 */
  has_blue_return?: boolean;
  /** part 16 */
  has_borrow_asset?: boolean;
  /** part 13 */
  has_depreciation_method_on_ta_for_dbm?: boolean;
  has_depreciation_method_on_ta_for_slm?: boolean;
  /** part 10 */
  has_non_taxable_asset?: boolean;
  /** part 12 */
  has_special_depreciation_or_compress_entry?: boolean;
  /** part 11 */
  has_taxation_standard_special?: boolean;
  id?: number;
  /** part 4 */
  industry_category?: string;
  lender_name?: string;
  name?: string;
  owner_address?: string;
  owner_address_kana?: string;
  /** part 17 */
  owner_category_of_building_of_company_rented_house?: boolean;
  owner_category_of_building_of_company_self_owned?: boolean;
  /** part 1 */
  owner_code?: string;
  owner_telephone?: string;
  owner_zip_code?: string;
  /** part 6 */
  person_in_charge_department?: string;
  person_in_charge_name?: string;
  person_in_charge_telephone?: string;
  /** part 18 */
  remark?: string;
  representative_name?: string;
  representative_name_kana?: string;
  representative_position?: string;
  /** part 7 */
  tax_accountant_name?: string;
  tax_accountant_telephone?: string;
}

export interface PresenterTaxDeclarationSummaryResponse {
  /** Total acquisition cost decreased in current year */
  acquisition_cost_decreased_current_year?: PresenterTotalAcquisitionCost;
  /** Total acquisition cost increased in current year */
  acquisition_cost_increased_current_year?: PresenterTotalAcquisitionCost;
  /** Total acquisition cost in the previous year */
  acquisition_cost_previous_year?: PresenterTotalAcquisitionCost;
  /** Total Summary */
  acquisition_cost_summary?: PresenterTotalAcquisitionCost;
  /** Amount Type Amounts returning. For example: [row asset type code][colum_index][[amount splitted 1] , [amount splitted 2], [amount splitted 3]] */
  asset_type_amounts?: string[][][];
  /** Submit destination */
  submit_destination?: PresenterTaxDeclarationSubmitDestination;
}

export interface PresenterTemporaryDataRequest {
  data: any;
  extra_key?: string;
  type: "create-fixed-asset edit-fixed-asset copy-fixed-asset";
}

export interface PresenterTemporaryDataResponse {
  data?: any;
  last_updated_at?: string;
  type?: ValueobjectAutoSaveType;
}

export interface PresenterTenantActivationStatusesRequest {
  tenant_uids?: number[];
}

export interface PresenterTenantActivationStatusesResponse {
  activated_at?: string;
  tenant_uid?: number;
}

export interface PresenterTenantUserActivationStatusesResponse {
  activated_at?: string;
  tenant_user_uid?: number;
}

export interface PresenterTermMonthFilter {
  "filter[time_date]"?: string;
}

export interface PresenterTotalAcquisitionCost {
  asset_types?: PresenterTotalAcquisitionCostDetail[];
  total?: number;
}

export interface PresenterTotalAcquisitionCostDetail {
  depreciable_property_tax_code?: ValueobjectAssetTypeForDepreciablePropertyTaxCode;
  total?: number;
}

export interface PresenterTypeItemAmount {
  amount_months?: PresenterAmountByMonth[];
  items?: PresenterAssetCategoryItemAmount[];
  items_department?: PresenterDepartmentItem[];
  total_amount?: number;
  type?: string;
}

export interface PresenterUpdateAIAgentSettingRequest {
  consent_agreed?: boolean;
  enabled?: boolean;
}

export interface PresenterUpdateAWebNotificationRequest {
  /** @min 1 */
  display_order: number;
  is_displayed?: boolean;
  is_highlighted?: boolean;
  released_at: string;
  /** @maxLength 255 */
  title: string;
  /** @maxLength 400 */
  url: string;
}

export interface PresenterUpdateAreaRequest {
  attachments?: PresenterAttachmentInformation[];
  biid?: string;
  code?: string;
  name?: string;
  photos?: PresenterPhotoInformation[];
  search_key?: string;
  submit_destination_id?: number;
  urls?: string[];
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterUpdateCauseRequest {
  code?: string;
  content?: string;
  search_key?: string;
  type?: number;
}

export interface PresenterUpdateContractRequest {
  end_date: string;
  reason: string;
  type: number;
}

export interface PresenterUpdateDepartmentRequest {
  biid?: string;
  code?: string;
  name?: string;
  prepress_category_code?: number;
  ref_id?: number;
  search_key?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface PresenterUpdateFixedAssetCommentRequest {
  content: string;
}

export interface PresenterUpdateFixedAssetTypeRequest {
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
}

export interface PresenterUpdateJournalItemSettingRequest {
  acquisition_credit_payment_category_account_item_id?: number;
  acquisition_credit_payment_category_account_sub_item_id?: number;
  /** Acquisition - 取得 */
  acquisition_debit_asset_category_account_item_id?: number;
  acquisition_debit_asset_category_account_sub_item_id?: number;
  /** @maxLength 1000 */
  acquisition_remark?: string;
  depreciation_credit_accumulated_account_item_id?: number;
  depreciation_credit_accumulated_account_sub_item_id?: number;
  depreciation_credit_asset_category_account_item_id?: number;
  depreciation_credit_asset_category_account_sub_item_id?: number;
  /** Depreciation - 減価償却 */
  depreciation_debit_account_item_id?: number;
  depreciation_debit_account_sub_item_id?: number;
  /** @maxLength 1000 */
  depreciation_remark?: string;
  impairment_credit_accumulated_impairment_account_item_id?: number;
  impairment_credit_accumulated_impairment_account_sub_item_id?: number;
  impairment_credit_asset_category_account_item_id?: number;
  impairment_credit_asset_category_account_sub_item_id?: number;
  /** Impairment */
  impairment_debit_loss_account_item_id?: number;
  impairment_debit_loss_account_sub_item_id?: number;
  /** @maxLength 1000 */
  impairment_remark?: string;
  retirement_credit_asset_category_account_item_id?: number;
  retirement_credit_asset_category_account_sub_item_id?: number;
  retirement_credit_payment_category_account_item_id?: number;
  retirement_credit_payment_category_account_sub_item_id?: number;
  /** Retirement - 除却 */
  retirement_debit_accumulated_depreciation_account_item_id?: number;
  retirement_debit_accumulated_depreciation_account_sub_item_id?: number;
  retirement_debit_accumulated_impairment_account_item_id?: number;
  retirement_debit_accumulated_impairment_account_sub_item_id?: number;
  retirement_debit_loss_account_item_id?: number;
  retirement_debit_loss_account_sub_item_id?: number;
  /** @maxLength 1000 */
  retirement_remark?: string;
  sale_credit_asset_category_account_item_id?: number;
  sale_credit_asset_category_account_sub_item_id?: number;
  sale_credit_gain_account_item_id?: number;
  sale_credit_gain_account_sub_item_id?: number;
  sale_credit_payment_category_account_item_id?: number;
  sale_credit_payment_category_account_sub_item_id?: number;
  /** Sale - 売却 */
  sale_debit_accumulated_depreciation_account_item_id?: number;
  sale_debit_accumulated_depreciation_account_sub_item_id?: number;
  sale_debit_accumulated_impairment_account_item_id?: number;
  sale_debit_accumulated_impairment_account_sub_item_id?: number;
  sale_debit_loss_account_item_id?: number;
  sale_debit_loss_account_sub_item_id?: number;
  sale_debit_revenue_account_item_id?: number;
  sale_debit_revenue_account_sub_item_id?: number;
  /** @maxLength 1000 */
  sale_remark?: string;
}

export interface PresenterUpdateSubmitDestinationRequest {
  apply_destination?: string;
  asset_location_1?: string;
  asset_location_2?: string;
  asset_location_3?: string;
  capital_amount?: number;
  city_code?: string;
  code?: string;
  commercial_name?: string;
  company_established_at_month?: number;
  company_established_at_year?: number;
  company_name?: string;
  company_name_kana?: string;
  corporate_code?: string;
  details_export_setting?: number;
  district_code?: string;
  has_additional_depreciation_report?: boolean;
  has_approval_of_shortened_service_life?: boolean;
  has_blue_return?: boolean;
  has_borrow_asset?: boolean;
  has_depreciation_method_on_ta_for_dbm?: boolean;
  has_depreciation_method_on_ta_for_slm?: boolean;
  has_non_taxable_asset?: boolean;
  has_special_depreciation_or_compress_entry?: boolean;
  has_taxation_standard_special?: boolean;
  industry_category?: string;
  lender_name?: string;
  name?: string;
  owner_address?: string;
  owner_address_kana?: string;
  owner_category_of_building_of_company_rented_house?: boolean;
  owner_category_of_building_of_company_self_owned?: boolean;
  owner_code?: string;
  /** @example "123-1234-122" */
  owner_telephone?: string;
  /** @example "123-1234" */
  owner_zip_code?: string;
  person_in_charge_department?: string;
  person_in_charge_name?: string;
  /** @example "123-1234-122" */
  person_in_charge_telephone?: string;
  remark?: string;
  representative_name?: string;
  representative_name_kana?: string;
  representative_position?: string;
  search_key?: string;
  tax_accountant_name?: string;
  /** @example "123-1234-122" */
  tax_accountant_telephone?: string;
}

export interface PresenterUpdateTagRequest {
  name?: string;
}

export interface PresenterUpdateUnitRequest {
  link_memorandum_value_quantity?: boolean;
  name?: string;
}

export interface PresenterUpsertDraftFixedAssetRequest {
  acquire_category_code: number;
  acquire_destination_name?: string;
  acquired_at: string;
  acquisition_cost: number;
  acquisition_cost_excluded_excise?: number;
  area_biid: string;
  asset_category_id: number;
  /** @maxLength 50 */
  asset_detail_for_corporate_tax?: string;
  /** @maxLength 50 */
  asset_structure_for_corporate_tax?: string;
  asset_type_for_corporate_tax_code?: number;
  asset_type_for_depreciable_property_tax_code?: number;
  /**
   * Assignments — required on create; omit on update to leave unchanged is NOT
   * supported by Upsert (all assignments must be sent each time for the diff).
   * @minItems 1
   */
  assignments: PresenterDraftAssignmentRequest[];
  calculated_excise_value?: number;
  department_biid?: string;
  event_cause_id?: number;
  event_urls?: string[];
  excise_id?: number;
  exemption_denominator?: number;
  exemption_numerator?: number;
  /** Ledgers — omit to prefill from the office's active LedgerSettings. */
  ledgers?: PresenterDraftFixedAssetLedgerRequest[];
  manual_excise_value?: number;
  memo?: string;
  /**
   * Basic Info — mirrors CreateFixedAssetRequest (no transition fields)
   * @maxLength 100
   */
  name: string;
  /** @maxLength 100 */
  name_kana?: string;
  /** @maxLength 50 */
  pre_submit_number?: string;
  quantity?: number;
  recognized_at?: string;
  reduction_amount?: number;
  subsidy_amount?: number;
  unit_id?: number;
  urls?: string[];
  usage_started_at?: string;
}

export interface PresenterUserInfo {
  display_name?: string;
  email?: string;
  family_name?: string;
  given_name?: string;
  id?: number;
  identification_code?: string;
  office_id?: number;
  office_identification_code?: string;
}

export interface PresenterValidateImportFixedAssetEventResponse {
  events?: DtoImportFixedAssetEvent[];
  unexpected_preview_error?: ErrorsResponseError;
  upload_url?: string;
}

export interface PresenterWithdrawUserAARequest {
  reason: string;
}

export interface PresenterWithdrawableStatus {
  withdrawable?: boolean;
}

export interface PresenterEvaluateBoolRequest {
  default_value?: boolean;
  key: string;
}

export interface PresenterEvaluateBoolResponse {
  enabled?: boolean;
  key?: string;
}

export interface ValueobjectFeaturePermission {
  feature_name?: string;
  operation_combined?: ValueobjectOperationCombined;
}

export type ValueobjectPermissionMap = Record<
  string,
  ValueobjectFeaturePermission
>;
